// src/data/catalogData.ts
export interface CatalogProduct {
 sNo?: number;
 modelNo: string;
 image?: string;
 description: string;
 capacity?: string;
 moldNos?: string;
 remarks?: string;
 packaging: string;
 inner: number;
 outer: number;
 inr: number;
 usd: number;
 moq: number;
 dimensions?: string;
 cbm?: number;
 monoDimensions?: string;
 innerDimensions?: string;
 masterDimensions?: string;
}

export interface ProductCategory {
 id: string;
 name: string;
 displayName: string;
 description: string;
 image: string;
 products: CatalogProduct[];
}

export const PRODUCT_CATEGORIES: ProductCategory[] = [
 {
 id: 'std-feeding',
 name: 'Std. Feeding',
 displayName: 'Standard Neck Feeding Bottles',
 description: 'Classic standard neck bottles with reliable performance and proven design. Perfect for everyday feeding with universal compatibility.',
 image: '/images/Standard Neck Bottles JPEG/RN0001 - 125ml.jpg',
 products: [
 {
 modelNo: 'RN0001-60ml',
 description: 'Zozo Straight Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 22,
 usd: 0.3259259259259259,
 moq: 3600,
 sNo: 1,
 capacity: '60ml',
 moldNos: 'RN0001',
 monoDimensions: 'L=5.2mm, B=5.2mm, H=12.2mm',
 innerDimensions: 'L=10.4mm, B=15.6mm, H=24.4mm',
 masterDimensions: 'L=20.8mm, B=46.8mm, H=48.8mm',
 cbm: 0.0475,
 },
 {
 modelNo: 'RN0001-125ml',
 description: 'Zozo Straight Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 24,
 usd: 0.3555555555555555,
 moq: 3600,
 sNo: 2,
 capacity: '125ml',
 moldNos: 'RN0001',
 monoDimensions: 'L=5.5mm, B=5.5mm, H=14.7mm',
 innerDimensions: 'L=11mm, B=16.5mm, H=29.4mm',
 masterDimensions: 'L=22mm, B=49.5mm, H=58.8mm',
 cbm: 0.064,
 },
 {
 modelNo: 'RN0001-250ml',
 description: 'Zozo Straight Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 26,
 usd: 0.3851851851851852,
 moq: 3600,
 sNo: 3,
 capacity: '250ml',
 moldNos: 'RN0001',
 monoDimensions: 'L=5.7mm, B=5.7mm, H=19.8mm',
 innerDimensions: 'L=11.4mm, B=17.1mm, H=39.6mm',
 masterDimensions: 'L=22.8mm, B=51.3mm, H=79.2mm',
 cbm: 0.0926,
 },
 {
 modelNo: 'RN0002-60ml',
 description: 'Zozo + Straight Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 23,
 usd: 0.34074074074074073,
 moq: 3600,
 sNo: 4,
 capacity: '60ml',
 moldNos: 'RN0002',
 monoDimensions: 'L=5.2mm, B=5.2mm, H=12.2mm',
 innerDimensions: 'L=10.4mm, B=15.6mm, H=24.4mm',
 masterDimensions: 'L=20.8mm, B=46.8mm, H=48.8mm',
 cbm: 0.0475,
 },
 {
 modelNo: 'RN0002-125ml',
 description: 'Zozo + Straight Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 25,
 usd: 0.37037037037037035,
 moq: 3600,
 sNo: 5,
 capacity: '125ml',
 moldNos: 'RN0002',
 monoDimensions: 'L=5.5mm, B=5.5mm, H=14.7mm',
 innerDimensions: 'L=11mm, B=16.5mm, H=29.4mm',
 masterDimensions: 'L=22mm, B=49.5mm, H=58.8mm',
 cbm: 0.064,
 },
 {
 modelNo: 'RN0002-250ml',
 description: 'Zozo + Straight Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 27,
 usd: 0.39999999999999997,
 moq: 3600,
 sNo: 6,
 capacity: '250ml',
 moldNos: 'RN0002',
 monoDimensions: 'L=5.7mm, B=5.7mm, H=19.8mm',
 innerDimensions: 'L=11.4mm, B=17.1mm, H=39.6mm',
 masterDimensions: 'L=22.8mm, B=51.3mm, H=79.2mm',
 cbm: 0.0926,
 },
 {
 modelNo: 'RN0003-60ml',
 description: 'Slender Straight Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 22,
 usd: 0.3259259259259259,
 moq: 3600,
 sNo: 7,
 capacity: '60ml',
 moldNos: 'RN0003',
 monoDimensions: 'L=5.2mm, B=5.2mm, H=12.2mm',
 innerDimensions: 'L=10.4mm, B=15.6mm, H=24.4mm',
 masterDimensions: 'L=20.8mm, B=46.8mm, H=48.8mm',
 cbm: 0.0475,
 },
 {
 modelNo: 'RN0003-125ml',
 description: 'Slender Straight Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 24,
 usd: 0.3555555555555555,
 moq: 3600,
 sNo: 8,
 capacity: '125ml',
 moldNos: 'RN0003',
 monoDimensions: 'L=5.5mm, B=5.5mm, H=14.7mm',
 innerDimensions: 'L=11mm, B=16.5mm, H=29.4mm',
 masterDimensions: 'L=22mm, B=49.5mm, H=58.8mm',
 cbm: 0.064,
 },
 {
 modelNo: 'RN0003-250ml',
 description: 'Slender Straight Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 26,
 usd: 0.3851851851851852,
 moq: 3600,
 sNo: 9,
 capacity: '250ml',
 moldNos: 'RN0003',
 monoDimensions: 'L=5.7mm, B=5.7mm, H=19.8mm',
 innerDimensions: 'L=11.4mm, B=17.1mm, H=39.6mm',
 masterDimensions: 'L=22.8mm, B=51.3mm, H=79.2mm',
 cbm: 0.0926,
 },
 {
 modelNo: 'RN0004-60ml',
 description: '3 Dot Straight Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 22.5,
 usd: 0.3333333333333333,
 moq: 3600,
 sNo: 10,
 capacity: '60ml',
 moldNos: 'RN0004',
 monoDimensions: 'L=5.2mm, B=5.2mm, H=12.2mm',
 innerDimensions: 'L=10.4mm, B=15.6mm, H=24.4mm',
 masterDimensions: 'L=20.8mm, B=46.8mm, H=48.8mm',
 cbm: 0.0475,
 },
 {
 modelNo: 'RN0004-125ml',
 description: '3 Dot Straight Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 24.5,
 usd: 0.36296296296296293,
 moq: 3600,
 sNo: 11,
 capacity: '125ml',
 moldNos: 'RN0004',
 monoDimensions: 'L=5.5mm, B=5.5mm, H=14.7mm',
 innerDimensions: 'L=11mm, B=16.5mm, H=29.4mm',
 masterDimensions: 'L=22mm, B=49.5mm, H=58.8mm',
 cbm: 0.064,
 },
 {
 modelNo: 'RN0004-250ml',
 description: '3 Dot Straight Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 26.5,
 usd: 0.39259259259259255,
 moq: 3600,
 sNo: 12,
 capacity: '250ml',
 moldNos: 'RN0004',
 monoDimensions: 'L=5.7mm, B=5.7mm, H=19.8mm',
 innerDimensions: 'L=11.4mm, B=17.1mm, H=39.6mm',
 masterDimensions: 'L=22.8mm, B=51.3mm, H=79.2mm',
 cbm: 0.0926,
 },
 {
 modelNo: 'RN0005-60ml',
 description: 'Thumb Straight Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 23,
 usd: 0.34074074074074073,
 moq: 3600,
 sNo: 13,
 capacity: '60ml',
 moldNos: 'RN0005',
 monoDimensions: 'L=5.2mm, B=5.2mm, H=12.2mm',
 innerDimensions: 'L=10.4mm, B=15.6mm, H=24.4mm',
 masterDimensions: 'L=20.8mm, B=46.8mm, H=48.8mm',
 cbm: 0.0475,
 },
 {
 modelNo: 'RN0005-125ml',
 description: 'Thumb Straight Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 25,
 usd: 0.37037037037037035,
 moq: 3600,
 sNo: 14,
 capacity: '125ml',
 moldNos: 'RN0005',
 monoDimensions: 'L=5.5mm, B=5.5mm, H=14.7mm',
 innerDimensions: 'L=11mm, B=16.5mm, H=29.4mm',
 masterDimensions: 'L=22mm, B=49.5mm, H=58.8mm',
 cbm: 0.064,
 },
 {
 modelNo: 'RN0005-250ml',
 description: 'Thumb Straight Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 27,
 usd: 0.39999999999999997,
 moq: 3600,
 sNo: 15,
 capacity: '250ml',
 moldNos: 'RN0005',
 monoDimensions: 'L=5.7mm, B=5.7mm, H=19.8mm',
 innerDimensions: 'L=11.4mm, B=17.1mm, H=39.6mm',
 masterDimensions: 'L=22.8mm, B=51.3mm, H=79.2mm',
 cbm: 0.0926,
 },
 {
 modelNo: 'RN0006-60ml',
 description: 'Crystal Straight Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 22,
 usd: 0.3259259259259259,
 moq: 3600,
 sNo: 16,
 capacity: '60ml',
 moldNos: 'RN0006',
 monoDimensions: 'L=5.2mm, B=5.2mm, H=12.2mm',
 innerDimensions: 'L=10.4mm, B=15.6mm, H=24.4mm',
 masterDimensions: 'L=20.8mm, B=46.8mm, H=48.8mm',
 cbm: 0.0475,
 },
 {
 modelNo: 'RN0006-125ml',
 description: 'Crystal Straight Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 24,
 usd: 0.3555555555555555,
 moq: 3600,
 sNo: 17,
 capacity: '125ml',
 moldNos: 'RN0006',
 monoDimensions: 'L=5.5mm, B=5.5mm, H=14.7mm',
 innerDimensions: 'L=11mm, B=16.5mm, H=29.4mm',
 masterDimensions: 'L=22mm, B=49.5mm, H=58.8mm',
 cbm: 0.064,
 },
 {
 modelNo: 'RN0006-250ml',
 description: 'Crystal Straight Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 26,
 usd: 0.3851851851851852,
 moq: 3600,
 sNo: 18,
 capacity: '250ml',
 moldNos: 'RN0006',
 monoDimensions: 'L=5.7mm, B=5.7mm, H=19.8mm',
 innerDimensions: 'L=11.4mm, B=17.1mm, H=39.6mm',
 masterDimensions: 'L=22.8mm, B=51.3mm, H=79.2mm',
 cbm: 0.0926,
 },
 {
 modelNo: 'RN0007-60ml',
 description: 'KK Straight Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 21.5,
 usd: 0.31851851851851853,
 moq: 3600,
 sNo: 19,
 capacity: '60ml',
 moldNos: 'RN0007',
 },
 {
 modelNo: 'RN0007-125ml',
 description: 'KK Straight Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 23.5,
 usd: 0.34814814814814815,
 moq: 3600,
 sNo: 20,
 capacity: '125ml',
 moldNos: 'RN0007',
 },
 {
 modelNo: 'RN0007-250ml',
 description: 'KK Straight Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 25.5,
 usd: 0.37777777777777777,
 moq: 3600,
 sNo: 21,
 capacity: '250ml',
 moldNos: 'RN0007',
 },
 {
 modelNo: 'RN0008-60ml',
 description: 'Zozo Curvy Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 22.5,
 usd: 0.3333333333333333,
 moq: 3600,
 sNo: 22,
 capacity: '60ml',
 moldNos: 'RN0008',
 monoDimensions: 'L=5.7mm, B=5.7mm, H=10.6mm',
 innerDimensions: 'L=11.4mm, B=17.1mm, H=21.2mm',
 masterDimensions: 'L=22.8mm, B=51.3mm, H=42.4mm',
 cbm: 0.0496,
 },
 {
 modelNo: 'RN0008-125ml',
 description: 'Zozo Curvy Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 24.5,
 usd: 0.36296296296296293,
 moq: 3600,
 sNo: 23,
 capacity: '125ml',
 moldNos: 'RN0008',
 monoDimensions: 'L=5.4mm, B=5.4mm, H=15.6mm',
 innerDimensions: 'L=10.8mm, B=16.2mm, H=31.2mm',
 masterDimensions: 'L=21.6mm, B=48.6mm, H=62.4mm',
 cbm: 0.0655,
 },
 {
 modelNo: 'RN0008-250ml',
 description: 'Zozo Curvy Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 26.5,
 usd: 0.39259259259259255,
 moq: 3600,
 sNo: 24,
 capacity: '250ml',
 moldNos: 'RN0008',
 monoDimensions: 'L=6.2mm, B=6.2mm, H=19.6mm',
 innerDimensions: 'L=12.4mm, B=18.6mm, H=39.2mm',
 masterDimensions: 'L=24.8mm, B=55.8mm, H=78.4mm',
 cbm: 0.1085,
 },
 {
 modelNo: 'RN0009-60ml',
 description: 'Zozo + Curvy Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 32,
 usd: 0.47407407407407404,
 moq: 3600,
 sNo: 25,
 capacity: '60ml',
 moldNos: 'RN0009',
 monoDimensions: 'L=5.7mm, B=5.7mm, H=10.6mm',
 innerDimensions: 'L=11.4mm, B=17.1mm, H=21.2mm',
 masterDimensions: 'L=22.8mm, B=51.3mm, H=42.4mm',
 cbm: 0.0496,
 },
 {
 modelNo: 'RN0009-125ml',
 description: '3in1 Zozo + Curvy Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 33.5,
 usd: 0.49629629629629624,
 moq: 3600,
 sNo: 26,
 capacity: '125ml',
 moldNos: 'RN0009',
 monoDimensions: 'L=5.4mm, B=5.4mm, H=15.6mm',
 innerDimensions: 'L=10.8mm, B=16.2mm, H=31.2mm',
 masterDimensions: 'L=21.6mm, B=48.6mm, H=62.4mm',
 cbm: 0.0655,
 },
 {
 modelNo: 'RN0009-250ml',
 description: '3in1 Zozo + Curvy Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 36.5,
 usd: 0.5407407407407407,
 moq: 3600,
 sNo: 27,
 capacity: '250ml',
 moldNos: 'RN0009',
 monoDimensions: 'L=6.2mm, B=6.2mm, H=19.6mm',
 innerDimensions: 'L=12.4mm, B=18.6mm, H=39.2mm',
 masterDimensions: 'L=24.8mm, B=55.8mm, H=78.4mm',
 cbm: 0.1085,
 },
 {
 modelNo: 'RN0010-60ml',
 description: 'Slender Curvy Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 23,
 usd: 0.34074074074074073,
 moq: 3600,
 sNo: 28,
 capacity: '60ml',
 moldNos: 'RN0010',
 monoDimensions: 'L=5.7mm, B=5.7mm, H=10.6mm',
 innerDimensions: 'L=11.4mm, B=17.1mm, H=21.2mm',
 masterDimensions: 'L=22.8mm, B=51.3mm, H=42.4mm',
 cbm: 0.0496,
 },
 {
 modelNo: 'RN0010-125ml',
 description: 'Slender Curvy Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 25,
 usd: 0.37037037037037035,
 moq: 3600,
 sNo: 29,
 capacity: '125ml',
 moldNos: 'RN0010',
 monoDimensions: 'L=5.4mm, B=5.4mm, H=15.6mm',
 innerDimensions: 'L=10.8mm, B=16.2mm, H=31.2mm',
 masterDimensions: 'L=21.6mm, B=48.6mm, H=62.4mm',
 cbm: 0.0655,
 },
 {
 modelNo: 'RN0010-250ml',
 description: 'Slender Curvy Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 27,
 usd: 0.39999999999999997,
 moq: 3600,
 sNo: 30,
 capacity: '250ml',
 moldNos: 'RN0010',
 monoDimensions: 'L=6.2mm, B=6.2mm, H=19.6mm',
 innerDimensions: 'L=12.4mm, B=18.6mm, H=39.2mm',
 masterDimensions: 'L=24.8mm, B=55.8mm, H=78.4mm',
 cbm: 0.1085,
 },
 {
 modelNo: 'RN0011-60ml',
 description: '3 Dot Curvy Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 23,
 usd: 0.34074074074074073,
 moq: 3600,
 sNo: 31,
 capacity: '60ml',
 moldNos: 'RN0011',
 monoDimensions: 'L=5.7mm, B=5.7mm, H=10.6mm',
 innerDimensions: 'L=11.4mm, B=17.1mm, H=21.2mm',
 masterDimensions: 'L=22.8mm, B=51.3mm, H=42.4mm',
 cbm: 0.0496,
 },
 {
 modelNo: 'RN0011-125ml',
 description: '3 Dot Curvy Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 25,
 usd: 0.37037037037037035,
 moq: 3600,
 sNo: 32,
 capacity: '125ml',
 moldNos: 'RN0011',
 monoDimensions: 'L=5.4mm, B=5.4mm, H=15.6mm',
 innerDimensions: 'L=10.8mm, B=16.2mm, H=31.2mm',
 masterDimensions: 'L=21.6mm, B=48.6mm, H=62.4mm',
 cbm: 0.0655,
 },
 {
 modelNo: 'RN0011-250ml',
 description: '3 Dot Curvy Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 27,
 usd: 0.39999999999999997,
 moq: 3600,
 sNo: 33,
 capacity: '250ml',
 moldNos: 'RN0011',
 monoDimensions: 'L=6.2mm, B=6.2mm, H=19.6mm',
 innerDimensions: 'L=12.4mm, B=18.6mm, H=39.2mm',
 masterDimensions: 'L=24.8mm, B=55.8mm, H=78.4mm',
 cbm: 0.1085,
 },
 {
 modelNo: 'RN0012-60ml',
 description: 'Thumb Curvy Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 23.5,
 usd: 0.34814814814814815,
 moq: 3600,
 sNo: 34,
 capacity: '60ml',
 moldNos: 'RN0012',
 monoDimensions: 'L=5.7mm, B=5.7mm, H=10.6mm',
 innerDimensions: 'L=11.4mm, B=17.1mm, H=21.2mm',
 masterDimensions: 'L=22.8mm, B=51.3mm, H=42.4mm',
 cbm: 0.0496,
 },
 {
 modelNo: 'RN0012-125ml',
 description: 'Thumb Curvy Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 26,
 usd: 0.3851851851851852,
 moq: 3600,
 sNo: 35,
 capacity: '125ml',
 moldNos: 'RN0012',
 monoDimensions: 'L=5.4mm, B=5.4mm, H=15.6mm',
 innerDimensions: 'L=10.8mm, B=16.2mm, H=31.2mm',
 masterDimensions: 'L=21.6mm, B=48.6mm, H=62.4mm',
 cbm: 0.0655,
 },
 {
 modelNo: 'RN0012-250ml',
 description: 'Thumb Curvy Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 28,
 usd: 0.41481481481481486,
 moq: 3600,
 sNo: 36,
 capacity: '250ml',
 moldNos: 'RN0012',
 monoDimensions: 'L=6.2mm, B=6.2mm, H=19.6mm',
 innerDimensions: 'L=12.4mm, B=18.6mm, H=39.2mm',
 masterDimensions: 'L=24.8mm, B=55.8mm, H=78.4mm',
 cbm: 0.1085,
 },
 {
 modelNo: 'RN0013-60ml',
 description: 'Crystal Curvy Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 24,
 usd: 0.3555555555555555,
 moq: 3600,
 sNo: 37,
 capacity: '60ml',
 moldNos: 'RN0013',
 monoDimensions: 'L=5.7mm, B=5.7mm, H=10.6mm',
 innerDimensions: 'L=11.4mm, B=17.1mm, H=21.2mm',
 masterDimensions: 'L=22.8mm, B=51.3mm, H=42.4mm',
 cbm: 0.0496,
 },
 {
 modelNo: 'RN0013-125ml',
 description: 'Crystal Curvy Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 26.5,
 usd: 0.39259259259259255,
 moq: 3600,
 sNo: 38,
 capacity: '125ml',
 moldNos: 'RN0013',
 monoDimensions: 'L=5.4mm, B=5.4mm, H=15.6mm',
 innerDimensions: 'L=10.8mm, B=16.2mm, H=31.2mm',
 masterDimensions: 'L=21.6mm, B=48.6mm, H=62.4mm',
 cbm: 0.0655,
 },
 {
 modelNo: 'RN0013-250ml',
 description: 'Crystal Curvy Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 28.5,
 usd: 0.42222222222222217,
 moq: 3600,
 sNo: 39,
 capacity: '250ml',
 moldNos: 'RN0013',
 monoDimensions: 'L=6.2mm, B=6.2mm, H=19.6mm',
 innerDimensions: 'L=12.4mm, B=18.6mm, H=39.2mm',
 masterDimensions: 'L=24.8mm, B=55.8mm, H=78.4mm',
 cbm: 0.1085,
 },
 {
 modelNo: 'RN0014-60ml',
 description: 'KK Curvy Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 22,
 usd: 0.3259259259259259,
 moq: 3600,
 sNo: 40,
 capacity: '60ml',
 moldNos: 'RN0014',
 },
 {
 modelNo: 'RN0014-125ml',
 description: 'KK Curvy Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 24,
 usd: 0.3555555555555555,
 moq: 3600,
 sNo: 41,
 capacity: '125ml',
 moldNos: 'RN0014',
 },
 {
 modelNo: 'RN0014-250ml',
 description: 'KK Curvy Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 26,
 usd: 0.3851851851851852,
 moq: 3600,
 sNo: 42,
 capacity: '250ml',
 moldNos: 'RN0014',
 },
 {
 modelNo: 'RN0015-120ml',
 description: 'Zozo Mambo Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 22,
 usd: 0.3259259259259259,
 moq: 3600,
 sNo: 43,
 capacity: '120ml',
 moldNos: 'RN0015',
 monoDimensions: 'L=5.5mm, B=5.5mm, H=15.6mm',
 innerDimensions: 'L=11mm, B=16.5mm, H=31.2mm',
 masterDimensions: 'L=22mm, B=49.5mm, H=62.4mm',
 cbm: 0.068,
 },
 {
 modelNo: 'RN0015-150ml',
 description: 'Zozo Mambo Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 23.5,
 usd: 0.34814814814814815,
 moq: 3600,
 sNo: 44,
 capacity: '150ml',
 moldNos: 'RN0015',
 monoDimensions: 'L=5.7mm, B=5.7mm, H=15.6mm',
 innerDimensions: 'L=11.4mm, B=17.1mm, H=31.2mm',
 masterDimensions: 'L=22.8mm, B=51.3mm, H=62.4mm',
 cbm: 0.073,
 },
 {
 modelNo: 'RN0015-180ml',
 description: 'Zozo Mambo Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 25,
 usd: 0.37037037037037035,
 moq: 3600,
 sNo: 45,
 capacity: '180ml',
 moldNos: 'RN0015',
 monoDimensions: 'L=5.5mm, B=5.5mm, H=15.9mm',
 innerDimensions: 'L=11mm, B=16.5mm, H=31.8mm',
 masterDimensions: 'L=22mm, B=49.5mm, H=63.6mm',
 cbm: 0.0693,
 },
 {
 modelNo: 'RN0015-300ml',
 description: 'Zozo Mambo Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 26.5,
 usd: 0.39259259259259255,
 moq: 3600,
 sNo: 46,
 capacity: '300ml',
 moldNos: 'RN0015',
 monoDimensions: 'L=6.3mm, B=6.3mm, H=19.6mm',
 innerDimensions: 'L=12.6mm, B=18.9mm, H=39.2mm',
 masterDimensions: 'L=25.2mm, B=56.7mm, H=78.4mm',
 cbm: 0.112,
 },
 {
 modelNo: 'RN0016-120ml',
 description: 'Zozo + Mambo Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 22.5,
 usd: 0.3333333333333333,
 moq: 3600,
 sNo: 47,
 capacity: '120ml',
 moldNos: 'RN0016',
 monoDimensions: 'L=5.5mm, B=5.5mm, H=15.6mm',
 innerDimensions: 'L=11mm, B=16.5mm, H=31.2mm',
 masterDimensions: 'L=22mm, B=49.5mm, H=62.4mm',
 cbm: 0.068,
 },
 {
 modelNo: 'RN0016-150ml',
 description: 'Zozo + Mambo Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 24,
 usd: 0.3555555555555555,
 moq: 3600,
 sNo: 48,
 capacity: '150ml',
 moldNos: 'RN0016',
 monoDimensions: 'L=5.7mm, B=5.7mm, H=15.6mm',
 innerDimensions: 'L=11.4mm, B=17.1mm, H=31.2mm',
 masterDimensions: 'L=22.8mm, B=51.3mm, H=62.4mm',
 cbm: 0.073,
 },
 {
 modelNo: 'RN0016-180ml',
 description: 'Zozo + Mambo Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 26,
 usd: 0.3851851851851852,
 moq: 3600,
 sNo: 49,
 capacity: '180ml',
 moldNos: 'RN0016',
 monoDimensions: 'L=5.5mm, B=5.5mm, H=15.9mm',
 innerDimensions: 'L=11mm, B=16.5mm, H=31.8mm',
 masterDimensions: 'L=22mm, B=49.5mm, H=63.6mm',
 cbm: 0.0693,
 },
 {
 modelNo: 'RN0016-300ml',
 description: 'Zozo + Mambo Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 27.5,
 usd: 0.4074074074074074,
 moq: 3600,
 sNo: 50,
 capacity: '300ml',
 moldNos: 'RN0016',
 monoDimensions: 'L=6.3mm, B=6.3mm, H=19.6mm',
 innerDimensions: 'L=12.6mm, B=18.9mm, H=39.2mm',
 masterDimensions: 'L=25.2mm, B=56.7mm, H=78.4mm',
 cbm: 0.112,
 },
 {
 modelNo: 'RN0017-120ml',
 description: 'Slender Mambo Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 23,
 usd: 0.34074074074074073,
 moq: 3600,
 sNo: 51,
 capacity: '120ml',
 moldNos: 'RN0017',
 monoDimensions: 'L=5.5mm, B=5.5mm, H=15.6mm',
 innerDimensions: 'L=11mm, B=16.5mm, H=31.2mm',
 masterDimensions: 'L=22mm, B=49.5mm, H=62.4mm',
 cbm: 0.068,
 },
 {
 modelNo: 'RN0017-150ml',
 description: 'Slender Mambo Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 24.5,
 usd: 0.36296296296296293,
 moq: 3600,
 sNo: 52,
 capacity: '150ml',
 moldNos: 'RN0017',
 monoDimensions: 'L=5.7mm, B=5.7mm, H=15.6mm',
 innerDimensions: 'L=11.4mm, B=17.1mm, H=31.2mm',
 masterDimensions: 'L=22.8mm, B=51.3mm, H=62.4mm',
 cbm: 0.073,
 },
 {
 modelNo: 'RN0017-180ml',
 description: 'Slender Mambo Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 26,
 usd: 0.3851851851851852,
 moq: 3600,
 sNo: 53,
 capacity: '180ml',
 moldNos: 'RN0017',
 monoDimensions: 'L=5.5mm, B=5.5mm, H=15.9mm',
 innerDimensions: 'L=11mm, B=16.5mm, H=31.8mm',
 masterDimensions: 'L=22mm, B=49.5mm, H=63.6mm',
 cbm: 0.0693,
 },
 {
 modelNo: 'RN0017-300ml',
 description: 'Slender Mambo Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 28,
 usd: 0.41481481481481486,
 moq: 3600,
 sNo: 54,
 capacity: '300ml',
 moldNos: 'RN0017',
 monoDimensions: 'L=6.3mm, B=6.3mm, H=19.6mm',
 innerDimensions: 'L=12.6mm, B=18.9mm, H=39.2mm',
 masterDimensions: 'L=25.2mm, B=56.7mm, H=78.4mm',
 cbm: 0.112,
 },
 {
 modelNo: 'RN0018-120ml',
 description: '3 Dot Mambo Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 22,
 usd: 0.3259259259259259,
 moq: 3600,
 sNo: 55,
 capacity: '120ml',
 moldNos: 'RN0018',
 monoDimensions: 'L=5.5mm, B=5.5mm, H=15.6mm',
 innerDimensions: 'L=11mm, B=16.5mm, H=31.2mm',
 masterDimensions: 'L=22mm, B=49.5mm, H=62.4mm',
 cbm: 0.068,
 },
 {
 modelNo: 'RN0018-150ml',
 description: '3 Dot Mambo Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 23,
 usd: 0.34074074074074073,
 moq: 3600,
 sNo: 56,
 capacity: '150ml',
 moldNos: 'RN0018',
 monoDimensions: 'L=5.7mm, B=5.7mm, H=15.6mm',
 innerDimensions: 'L=11.4mm, B=17.1mm, H=31.2mm',
 masterDimensions: 'L=22.8mm, B=51.3mm, H=62.4mm',
 cbm: 0.073,
 },
 {
 modelNo: 'RN0018-180ml',
 description: '3 Dot Mambo Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 23,
 usd: 0.34074074074074073,
 moq: 3600,
 sNo: 57,
 capacity: '180ml',
 moldNos: 'RN0018',
 monoDimensions: 'L=5.5mm, B=5.5mm, H=15.9mm',
 innerDimensions: 'L=11mm, B=16.5mm, H=31.8mm',
 masterDimensions: 'L=22mm, B=49.5mm, H=63.6mm',
 cbm: 0.0693,
 },
 {
 modelNo: 'RN0018-300ml',
 description: '3 Dot Mambo Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 26,
 usd: 0.3851851851851852,
 moq: 3600,
 sNo: 58,
 capacity: '300ml',
 moldNos: 'RN0018',
 monoDimensions: 'L=6.3mm, B=6.3mm, H=19.6mm',
 innerDimensions: 'L=12.6mm, B=18.9mm, H=39.2mm',
 masterDimensions: 'L=25.2mm, B=56.7mm, H=78.4mm',
 cbm: 0.112,
 },
 {
 modelNo: 'RN0019-120ml',
 description: 'Thumb Mambo Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 23,
 usd: 0.34074074074074073,
 moq: 3600,
 sNo: 59,
 capacity: '120ml',
 moldNos: 'RN0019',
 monoDimensions: 'L=5.5mm, B=5.5mm, H=15.6mm',
 innerDimensions: 'L=11mm, B=16.5mm, H=31.2mm',
 masterDimensions: 'L=22mm, B=49.5mm, H=62.4mm',
 cbm: 0.068,
 },
 {
 modelNo: 'RN0019-150ml',
 description: 'Thumb Mambo Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 24,
 usd: 0.3555555555555555,
 moq: 3600,
 sNo: 60,
 capacity: '150ml',
 moldNos: 'RN0019',
 monoDimensions: 'L=5.7mm, B=5.7mm, H=15.6mm',
 innerDimensions: 'L=11.4mm, B=17.1mm, H=31.2mm',
 masterDimensions: 'L=22.8mm, B=51.3mm, H=62.4mm',
 cbm: 0.073,
 },
 {
 modelNo: 'RN0019-180ml',
 description: 'Thumb Mambo Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 25,
 usd: 0.37037037037037035,
 moq: 3600,
 sNo: 61,
 capacity: '180ml',
 moldNos: 'RN0019',
 monoDimensions: 'L=5.5mm, B=5.5mm, H=15.9mm',
 innerDimensions: 'L=11mm, B=16.5mm, H=31.8mm',
 masterDimensions: 'L=22mm, B=49.5mm, H=63.6mm',
 cbm: 0.0693,
 },
 {
 modelNo: 'RN0019-300ml',
 description: 'Thumb Mambo Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 27,
 usd: 0.39999999999999997,
 moq: 3600,
 sNo: 62,
 capacity: '300ml',
 moldNos: 'RN0019',
 monoDimensions: 'L=6.3mm, B=6.3mm, H=19.6mm',
 innerDimensions: 'L=12.6mm, B=18.9mm, H=39.2mm',
 masterDimensions: 'L=25.2mm, B=56.7mm, H=78.4mm',
 cbm: 0.112,
 },
 {
 modelNo: 'RN0020-120ml',
 description: '3in1 Crystal Mambo Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 30,
 usd: 0.4444444444444444,
 moq: 3600,
 sNo: 63,
 capacity: '120ml',
 moldNos: 'RN0020',
 monoDimensions: 'L=5.5mm, B=5.5mm, H=15.6mm',
 innerDimensions: 'L=11mm, B=16.5mm, H=31.2mm',
 masterDimensions: 'L=22mm, B=49.5mm, H=62.4mm',
 cbm: 0.068,
 },
 {
 modelNo: 'RN0020-150ml',
 description: '3in1 Crystal Mambo Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 31,
 usd: 0.4592592592592592,
 moq: 3600,
 sNo: 64,
 capacity: '150ml',
 moldNos: 'RN0020',
 monoDimensions: 'L=5.7mm, B=5.7mm, H=15.6mm',
 innerDimensions: 'L=11.4mm, B=17.1mm, H=31.2mm',
 masterDimensions: 'L=22.8mm, B=51.3mm, H=62.4mm',
 cbm: 0.073,
 },
 {
 modelNo: 'RN0020-180ml',
 description: '3in1 Crystal Mambo Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 32,
 usd: 0.47407407407407404,
 moq: 3600,
 sNo: 65,
 capacity: '180ml',
 moldNos: 'RN0020',
 monoDimensions: 'L=5.5mm, B=5.5mm, H=15.9mm',
 innerDimensions: 'L=11mm, B=16.5mm, H=31.8mm',
 masterDimensions: 'L=22mm, B=49.5mm, H=63.6mm',
 cbm: 0.0693,
 },
 {
 modelNo: 'RN0020-300ml',
 description: '3in1 Crystal Mambo Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 34,
 usd: 0.5037037037037037,
 moq: 3600,
 sNo: 66,
 capacity: '300ml',
 moldNos: 'RN0020',
 monoDimensions: 'L=6.3mm, B=6.3mm, H=19.6mm',
 innerDimensions: 'L=12.6mm, B=18.9mm, H=39.2mm',
 masterDimensions: 'L=25.2mm, B=56.7mm, H=78.4mm',
 cbm: 0.112,
 },
 {
 modelNo: 'RN0021-120ml',
 description: 'KK Mambo Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 22,
 usd: 0.3259259259259259,
 moq: 3600,
 sNo: 67,
 capacity: '120ml',
 moldNos: 'RN0021',
 },
 {
 modelNo: 'RN0021-150ml',
 description: 'KK Mambo Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 23,
 usd: 0.34074074074074073,
 moq: 3600,
 sNo: 68,
 capacity: '150ml',
 moldNos: 'RN0021',
 },
 {
 modelNo: 'RN0021-180ml',
 description: 'KK Mambo Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 24,
 usd: 0.3555555555555555,
 moq: 3600,
 sNo: 69,
 capacity: '180ml',
 moldNos: 'RN0021',
 },
 {
 modelNo: 'RN0021-300ml',
 description: 'KK Mambo Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 26,
 usd: 0.3851851851851852,
 moq: 3600,
 sNo: 70,
 capacity: '300ml',
 moldNos: 'RN0021',
 },
 {
 modelNo: 'RN0022-180ml',
 description: 'Zozo Aqua Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 24.5,
 usd: 0.36296296296296293,
 moq: 3600,
 sNo: 71,
 capacity: '180ml',
 moldNos: 'RN0022',
 },
 {
 modelNo: 'RN0022-270ml',
 description: 'Zozo Aqua Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 27.5,
 usd: 0.4074074074074074,
 moq: 3600,
 sNo: 72,
 capacity: '270ml',
 moldNos: 'RN0022',
 monoDimensions: 'L=6.4mm, B=6.4mm, H=19.6mm',
 innerDimensions: 'L=12.8mm, B=19.2mm, H=39.2mm',
 masterDimensions: 'L=25.6mm, B=57.6mm, H=78.4mm',
 cbm: 0.1156,
 },
 {
 modelNo: 'RN0023-180ml',
 description: 'Zozo + Aqua Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 26,
 usd: 0.3851851851851852,
 moq: 3600,
 sNo: 73,
 capacity: '180ml',
 moldNos: 'RN0023',
 },
 {
 modelNo: 'RN0023-270ml',
 description: 'Zozo + Aqua Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 29,
 usd: 0.4296296296296296,
 moq: 3600,
 sNo: 74,
 capacity: '270ml',
 moldNos: 'RN0023',
 monoDimensions: 'L=6.4mm, B=6.4mm, H=19.6mm',
 innerDimensions: 'L=12.8mm, B=19.2mm, H=39.2mm',
 masterDimensions: 'L=25.6mm, B=57.6mm, H=78.4mm',
 cbm: 0.1156,
 },
 {
 modelNo: 'RN0024-180ml',
 description: 'Slender Aqua Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 25,
 usd: 0.37037037037037035,
 moq: 3600,
 sNo: 75,
 capacity: '180ml',
 moldNos: 'RN0024',
 },
 {
 modelNo: 'RN0024-270ml',
 description: 'Slender Aqua Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 28,
 usd: 0.41481481481481486,
 moq: 3600,
 sNo: 76,
 capacity: '270ml',
 moldNos: 'RN0024',
 monoDimensions: 'L=6.4mm, B=6.4mm, H=19.6mm',
 innerDimensions: 'L=12.8mm, B=19.2mm, H=39.2mm',
 masterDimensions: 'L=25.6mm, B=57.6mm, H=78.4mm',
 cbm: 0.1156,
 },
 {
 modelNo: 'RN0025-180ml',
 description: '3 Dot Aqua Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 24.5,
 usd: 0.36296296296296293,
 moq: 3600,
 sNo: 77,
 capacity: '180ml',
 moldNos: 'RN0025',
 },
 {
 modelNo: 'RN0025-270ml',
 description: '3 Dot Aqua Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 27,
 usd: 0.39999999999999997,
 moq: 3600,
 sNo: 78,
 capacity: '270ml',
 moldNos: 'RN0025',
 monoDimensions: 'L=6.4mm, B=6.4mm, H=19.6mm',
 innerDimensions: 'L=12.8mm, B=19.2mm, H=39.2mm',
 masterDimensions: 'L=25.6mm, B=57.6mm, H=78.4mm',
 cbm: 0.1156,
 },
 {
 modelNo: 'RN0026-180ml',
 description: 'Thumb Aqua Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 25.5,
 usd: 0.37777777777777777,
 moq: 3600,
 sNo: 79,
 capacity: '180ml',
 moldNos: 'RN0026',
 },
 {
 modelNo: 'RN0026-270ml',
 description: 'Thumb Aqua Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 29,
 usd: 0.4296296296296296,
 moq: 3600,
 sNo: 80,
 capacity: '270ml',
 moldNos: 'RN0026',
 monoDimensions: 'L=6.4mm, B=6.4mm, H=19.6mm',
 innerDimensions: 'L=12.8mm, B=19.2mm, H=39.2mm',
 masterDimensions: 'L=25.6mm, B=57.6mm, H=78.4mm',
 cbm: 0.1156,
 },
 {
 modelNo: 'RN0027-180ml',
 description: 'Crystal Aqua Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 26.5,
 usd: 0.39259259259259255,
 moq: 3600,
 sNo: 81,
 capacity: '180ml',
 moldNos: 'RN0027',
 },
 {
 modelNo: 'RN0027-270ml',
 description: 'Crystal Aqua Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 29,
 usd: 0.4296296296296296,
 moq: 3600,
 sNo: 82,
 capacity: '270ml',
 moldNos: 'RN0027',
 monoDimensions: 'L=6.4mm, B=6.4mm, H=19.6mm',
 innerDimensions: 'L=12.8mm, B=19.2mm, H=39.2mm',
 masterDimensions: 'L=25.6mm, B=57.6mm, H=78.4mm',
 cbm: 0.1156,
 },
 {
 modelNo: 'RN0028-180ml',
 description: 'KK Aqua Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 25,
 usd: 0.37037037037037035,
 moq: 3600,
 sNo: 83,
 capacity: '180ml',
 moldNos: 'RN0028',
 },
 {
 modelNo: 'RN0028-270ml',
 description: 'KK Aqua Std. Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 28,
 usd: 0.41481481481481486,
 moq: 3600,
 sNo: 84,
 capacity: '270ml',
 moldNos: 'RN0028',
 },
 {
 modelNo: 'RN0029-125ml',
 description: 'Zozo Straight Std. Neck Feeding Bottle with Apple Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 30,
 usd: 0.4444444444444444,
 moq: 3600,
 capacity: '125ml',
 moldNos: 'RN0029',
 monoDimensions: 'L=5.3mm, B=9.9mm, H=15.8mm',
 innerDimensions: 'L=10.6mm, B=29.7mm, H=31.6mm',
 masterDimensions: 'L=21.2mm, B=89.1mm, H=63.2mm',
 cbm: 0.1193,
 },
 {
 modelNo: 'RN0029-250ml',
 description: 'Zozo Straight Std. Neck Feeding Bottle with Apple Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 33,
 usd: 0.48888888888888893,
 moq: 3600,
 capacity: '250ml',
 moldNos: 'RN0029',
 monoDimensions: 'L=5.7mm, B=9.9mm, H=19.2mm',
 innerDimensions: 'L=11.4mm, B=29.7mm, H=38.4mm',
 masterDimensions: 'L=22.8mm, B=89.1mm, H=76.8mm',
 cbm: 0.156,
 },
 {
 modelNo: 'RN0030-125ml',
 description: '2in1 Zozo + Straight Std. Neck Feeding Bottle with Zozo+ Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 37,
 usd: 0.5481481481481482,
 moq: 3600,
 capacity: '125ml',
 moldNos: 'RN0030',
 },
 {
 modelNo: 'RN0030-250ml',
 description: '2in1 Zozo + Straight Std. Neck Feeding Bottle with Zozo+ Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 40,
 usd: 0.5925925925925926,
 moq: 3600,
 capacity: '250ml',
 moldNos: 'RN0030',
 },
 {
 modelNo: 'RN0031-125ml',
 description: 'Slender Straight Std. Neck Feeding Bottle with Slender Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 31,
 usd: 0.4592592592592592,
 moq: 3600,
 capacity: '125ml',
 moldNos: 'RN0031',
 monoDimensions: 'L=5.3mm, B=9.9mm, H=15.8mm',
 innerDimensions: 'L=10.6mm, B=29.7mm, H=31.6mm',
 masterDimensions: 'L=21.2mm, B=89.1mm, H=63.2mm',
 cbm: 0.1193,
 },
 {
 modelNo: 'RN0031-250ml',
 description: 'Slender Straight Std. Neck Feeding Bottle with Slender Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 34,
 usd: 0.5037037037037037,
 moq: 3600,
 capacity: '250ml',
 moldNos: 'RN0031',
 monoDimensions: 'L=5.7mm, B=9.9mm, H=19.2mm',
 innerDimensions: 'L=11.4mm, B=29.7mm, H=38.4mm',
 masterDimensions: 'L=22.8mm, B=89.1mm, H=76.8mm',
 cbm: 0.156,
 },
 {
 modelNo: 'RN0032-125ml',
 description: '3 Dot Straight Std. Neck Feeding Bottle with Slender Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 32,
 usd: 0.47407407407407404,
 moq: 3600,
 capacity: '125ml',
 moldNos: 'RN0032',
 monoDimensions: 'L=5.3mm, B=9.9mm, H=15.8mm',
 innerDimensions: 'L=10.6mm, B=29.7mm, H=31.6mm',
 masterDimensions: 'L=21.2mm, B=89.1mm, H=63.2mm',
 cbm: 0.1193,
 },
 {
 modelNo: 'RN0032-250ml',
 description: '3 Dot Straight Std. Neck Feeding Bottle with Slender Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 36,
 usd: 0.5333333333333333,
 moq: 3600,
 capacity: '250ml',
 moldNos: 'RN0032',
 monoDimensions: 'L=5.7mm, B=9.9mm, H=19.2mm',
 innerDimensions: 'L=11.4mm, B=29.7mm, H=38.4mm',
 masterDimensions: 'L=22.8mm, B=89.1mm, H=76.8mm',
 cbm: 0.156,
 },
 {
 modelNo: 'RN0033-125ml',
 description: 'Thumb Straight Std. Neck Feeding Bottle with Apple Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 31.5,
 usd: 0.4666666666666666,
 moq: 3600,
 capacity: '125ml',
 moldNos: 'RN0033',
 monoDimensions: 'L=5.3mm, B=9.9mm, H=15.8mm',
 innerDimensions: 'L=10.6mm, B=29.7mm, H=31.6mm',
 masterDimensions: 'L=21.2mm, B=89.1mm, H=63.2mm',
 cbm: 0.1193,
 },
 {
 modelNo: 'RN0033-250ml',
 description: 'Thumb Straight Std. Neck Feeding Bottle with Apple Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 34.5,
 usd: 0.5111111111111111,
 moq: 3600,
 capacity: '250ml',
 moldNos: 'RN0033',
 monoDimensions: 'L=5.7mm, B=9.9mm, H=19.2mm',
 innerDimensions: 'L=11.4mm, B=29.7mm, H=38.4mm',
 masterDimensions: 'L=22.8mm, B=89.1mm, H=76.8mm',
 cbm: 0.156,
 },
 {
 modelNo: 'RN0034-125ml',
 description: 'Crystal Straight Std. Neck Feeding Bottle with Rondo Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 31,
 usd: 0.4592592592592592,
 moq: 3600,
 capacity: '125ml',
 moldNos: 'RN0034',
 monoDimensions: 'L=5.3mm, B=9.9mm, H=15.8mm',
 innerDimensions: 'L=10.6mm, B=29.7mm, H=31.6mm',
 masterDimensions: 'L=21.2mm, B=89.1mm, H=63.2mm',
 cbm: 0.1193,
 },
 {
 modelNo: 'RN0034-250ml',
 description: 'Crystal Straight Std. Neck Feeding Bottle with Rondo Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 34,
 usd: 0.5037037037037037,
 moq: 3600,
 capacity: '250ml',
 moldNos: 'RN0034',
 monoDimensions: 'L=5.7mm, B=9.9mm, H=19.2mm',
 innerDimensions: 'L=11.4mm, B=29.7mm, H=38.4mm',
 masterDimensions: 'L=22.8mm, B=89.1mm, H=76.8mm',
 cbm: 0.156,
 },
 {
 modelNo: 'RN0035-125ml',
 description: 'KK Straight Std. Neck Feeding Bottle with KK Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 30,
 usd: 0.4444444444444444,
 moq: 3600,
 capacity: '125ml',
 moldNos: 'RN0035',
 },
 {
 modelNo: 'RN0035-250ml',
 description: 'KK Straight Std. Neck Feeding Bottle with KK Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 33,
 usd: 0.48888888888888893,
 moq: 3600,
 capacity: '250ml',
 moldNos: 'RN0035',
 },
 {
 modelNo: 'RN0036-125ml',
 description: 'Zozo Curvy Std. Neck Feeding Bottle with Rondo Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 32,
 usd: 0.47407407407407404,
 moq: 3600,
 capacity: '125ml',
 moldNos: 'RN0036',
 monoDimensions: 'L=5.3mm, B=9.9mm, H=15.8mm',
 innerDimensions: 'L=10.6mm, B=29.7mm, H=31.6mm',
 masterDimensions: 'L=21.2mm, B=89.1mm, H=63.2mm',
 cbm: 0.1193,
 },
 {
 modelNo: 'RN0036-250ml',
 description: 'Zozo Curvy Std. Neck Feeding Bottle with Rondo Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 36,
 usd: 0.5333333333333333,
 moq: 3600,
 capacity: '250ml',
 moldNos: 'RN0036',
 monoDimensions: 'L=5.7mm, B=9.9mm, H=19.2mm',
 innerDimensions: 'L=11.4mm, B=29.7mm, H=38.4mm',
 masterDimensions: 'L=22.8mm, B=89.1mm, H=76.8mm',
 cbm: 0.156,
 },
 {
 modelNo: 'RN0037-125ml',
 description: '3in1 Zozo + Curvy Std. Neck Feeding Bottle with zozo+ Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 40,
 usd: 0.5925925925925926,
 moq: 3600,
 capacity: '125ml',
 moldNos: 'RN0037',
 },
 {
 modelNo: 'RN0037-250ml',
 description: '3in1 Zozo + Curvy Std. Neck Feeding Bottle with zozo+ Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 42,
 usd: 0.6222222222222222,
 moq: 3600,
 capacity: '250ml',
 moldNos: 'RN0037',
 },
 {
 modelNo: 'RN0038-125ml',
 description: 'Slender Curvy Std. Neck Feeding Bottle with Rondo Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 34,
 usd: 0.5037037037037037,
 moq: 3600,
 capacity: '125ml',
 moldNos: 'RN0038',
 monoDimensions: 'L=5.3mm, B=9.9mm, H=15.8mm',
 innerDimensions: 'L=10.6mm, B=29.7mm, H=31.6mm',
 masterDimensions: 'L=21.2mm, B=89.1mm, H=63.2mm',
 cbm: 0.1193,
 },
 {
 modelNo: 'RN0038-250ml',
 description: 'Slender Curvy Std. Neck Feeding Bottle with Rondo Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 37,
 usd: 0.5481481481481482,
 moq: 3600,
 capacity: '250ml',
 moldNos: 'RN0038',
 monoDimensions: 'L=5.7mm, B=9.9mm, H=19.2mm',
 innerDimensions: 'L=11.4mm, B=29.7mm, H=38.4mm',
 masterDimensions: 'L=22.8mm, B=89.1mm, H=76.8mm',
 cbm: 0.156,
 },
 {
 modelNo: 'RN0039-125ml',
 description: '3 Dot Curvy Std. Neck Feeding Bottle with Rondo Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 34,
 usd: 0.5037037037037037,
 moq: 3600,
 capacity: '125ml',
 moldNos: 'RN0039',
 monoDimensions: 'L=5.3mm, B=9.9mm, H=15.8mm',
 innerDimensions: 'L=10.6mm, B=29.7mm, H=31.6mm',
 masterDimensions: 'L=21.2mm, B=89.1mm, H=63.2mm',
 cbm: 0.1193,
 },
 {
 modelNo: 'RN0039-250ml',
 description: '3 Dot Curvy Std. Neck Feeding Bottle with Rondo Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 37,
 usd: 0.5481481481481482,
 moq: 3600,
 capacity: '250ml',
 moldNos: 'RN0039',
 monoDimensions: 'L=5.7mm, B=9.9mm, H=19.2mm',
 innerDimensions: 'L=11.4mm, B=29.7mm, H=38.4mm',
 masterDimensions: 'L=22.8mm, B=89.1mm, H=76.8mm',
 cbm: 0.156,
 },
 {
 modelNo: 'RN0040-125ml',
 description: 'Thumb Curvy Std. Neck Feeding Bottle with Apple Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 35,
 usd: 0.5185185185185185,
 moq: 3600,
 capacity: '125ml',
 moldNos: 'RN0040',
 monoDimensions: 'L=5.3mm, B=9.9mm, H=15.8mm',
 innerDimensions: 'L=10.6mm, B=29.7mm, H=31.6mm',
 masterDimensions: 'L=21.2mm, B=89.1mm, H=63.2mm',
 cbm: 0.1193,
 },
 {
 modelNo: 'RN0040-250ml',
 description: 'Thumb Curvy Std. Neck Feeding Bottle with Apple Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 38,
 usd: 0.562962962962963,
 moq: 3600,
 capacity: '250ml',
 moldNos: 'RN0040',
 monoDimensions: 'L=5.7mm, B=9.9mm, H=19.2mm',
 innerDimensions: 'L=11.4mm, B=29.7mm, H=38.4mm',
 masterDimensions: 'L=22.8mm, B=89.1mm, H=76.8mm',
 cbm: 0.156,
 },
 {
 modelNo: 'RN0041-125ml',
 description: '2in1 Crystal Curvy Std. Neck Feeding Bottle with Apple Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 38,
 usd: 0.562962962962963,
 moq: 3600,
 capacity: '125ml',
 moldNos: 'RN0041',
 monoDimensions: 'L=5.3mm, B=9.9mm, H=15.8mm',
 innerDimensions: 'L=10.6mm, B=29.7mm, H=31.6mm',
 masterDimensions: 'L=21.2mm, B=89.1mm, H=63.2mm',
 cbm: 0.1193,
 },
 {
 modelNo: 'RN0041-250ml',
 description: '2in1 Crystal Curvy Std. Neck Feeding Bottle with Apple Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 40,
 usd: 0.5925925925925926,
 moq: 3600,
 capacity: '250ml',
 moldNos: 'RN0041',
 monoDimensions: 'L=5.7mm, B=9.9mm, H=19.2mm',
 innerDimensions: 'L=11.4mm, B=29.7mm, H=38.4mm',
 masterDimensions: 'L=22.8mm, B=89.1mm, H=76.8mm',
 cbm: 0.156,
 },
 {
 modelNo: 'RN0042-125ml',
 description: 'KK Curvy Std. Neck Feeding Bottle with KK Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 32,
 usd: 0.47407407407407404,
 moq: 3600,
 capacity: '125ml',
 moldNos: 'RN0042',
 },
 {
 modelNo: 'RN0042-250ml',
 description: 'KK Curvy Std. Neck Feeding Bottle with KK Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 35,
 usd: 0.5185185185185185,
 moq: 3600,
 capacity: '250ml',
 moldNos: 'RN0042',
 },
 {
 modelNo: 'RN0043-180ml',
 description: 'Zozo Mambo Std. Neck Feeding Bottle with Apple Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 31,
 usd: 0.4592592592592592,
 moq: 3600,
 capacity: '180ml',
 moldNos: 'RN0043',
 monoDimensions: 'L=5.5mm, B=10.2mm, H=15.9mm',
 innerDimensions: 'L=11mm, B=30.6mm, H=31.8mm',
 masterDimensions: 'L=22mm, B=91.8mm, H=63.6mm',
 cbm: 0.1284,
 },
 {
 modelNo: 'RN0043-300ml',
 description: 'Zozo Mambo Std. Neck Feeding Bottle with Apple Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 33,
 usd: 0.48888888888888893,
 moq: 3600,
 capacity: '300ml',
 moldNos: 'RN0043',
 monoDimensions: 'L=5.9mm, B=10.3mm, H=19.9mm',
 innerDimensions: 'L=11.8mm, B=30.9mm, H=39.8mm',
 masterDimensions: 'L=23.6mm, B=92.7mm, H=79.6mm',
 cbm: 0.1741,
 },
 {
 modelNo: 'RN0044-180ml',
 description: 'Zozo Mambo Std. Neck Feeding Bottle with Zozo+ Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 33,
 usd: 0.48888888888888893,
 moq: 3600,
 capacity: '180ml',
 moldNos: 'RN0044',
 },
 {
 modelNo: 'RN0044-300ml',
 description: 'Zozo Mambo Std. Neck Feeding Bottle with Zozo+ Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 36,
 usd: 0.5333333333333333,
 moq: 3600,
 capacity: '300ml',
 moldNos: 'RN0044',
 },
 {
 modelNo: 'RN0045-180ml',
 description: 'Slender Mambo Std. Neck Feeding Bottle with Slender Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 34,
 usd: 0.5037037037037037,
 moq: 3600,
 capacity: '180ml',
 moldNos: 'RN0045',
 monoDimensions: 'L=5.5mm, B=10.2mm, H=15.9mm',
 innerDimensions: 'L=11mm, B=30.6mm, H=31.8mm',
 masterDimensions: 'L=22mm, B=91.8mm, H=63.6mm',
 cbm: 0.1284,
 },
 {
 modelNo: 'RN0045-300ml',
 description: 'Slender Mambo Std. Neck Feeding Bottle with Slender Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 38,
 usd: 0.562962962962963,
 moq: 3600,
 capacity: '300ml',
 moldNos: 'RN0045',
 monoDimensions: 'L=5.9mm, B=10.3mm, H=19.9mm',
 innerDimensions: 'L=11.8mm, B=30.9mm, H=39.8mm',
 masterDimensions: 'L=23.6mm, B=92.7mm, H=79.6mm',
 cbm: 0.1741,
 },
 {
 modelNo: 'RN0046-180ml',
 description: '3 Dot Mambo Std. Neck Feeding Bottle with Apple Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 34.5,
 usd: 0.5111111111111111,
 moq: 3600,
 capacity: '180ml',
 moldNos: 'RN0046',
 monoDimensions: 'L=5.5mm, B=10.2mm, H=15.9mm',
 innerDimensions: 'L=11mm, B=30.6mm, H=31.8mm',
 masterDimensions: 'L=22mm, B=91.8mm, H=63.6mm',
 cbm: 0.1284,
 },
 {
 modelNo: 'RN0046-300ml',
 description: '3 Dot Mambo Std. Neck Feeding Bottle with Apple Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 37.5,
 usd: 0.5555555555555556,
 moq: 3600,
 capacity: '300ml',
 moldNos: 'RN0046',
 monoDimensions: 'L=5.9mm, B=10.3mm, H=19.9mm',
 innerDimensions: 'L=11.8mm, B=30.9mm, H=39.8mm',
 masterDimensions: 'L=23.6mm, B=92.7mm, H=79.6mm',
 cbm: 0.1741,
 },
 {
 modelNo: 'RN0047-180ml',
 description: '2in1 Thumb Mambo Std. Neck Feeding Bottle Rondo Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 39,
 usd: 0.5777777777777777,
 moq: 3600,
 capacity: '180ml',
 moldNos: 'RN0047',
 monoDimensions: 'L=5.5mm, B=10.2mm, H=15.9mm',
 innerDimensions: 'L=11mm, B=30.6mm, H=31.8mm',
 masterDimensions: 'L=22mm, B=91.8mm, H=63.6mm',
 cbm: 0.1284,
 },
 {
 modelNo: 'RN0047-300ml',
 description: '2in1 Thumb Mambo Std. Neck Feeding Bottle Rondo Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 42,
 usd: 0.6222222222222222,
 moq: 3600,
 capacity: '300ml',
 moldNos: 'RN0047',
 monoDimensions: 'L=5.9mm, B=10.3mm, H=19.9mm',
 innerDimensions: 'L=11.8mm, B=30.9mm, H=39.8mm',
 masterDimensions: 'L=23.6mm, B=92.7mm, H=79.6mm',
 cbm: 0.1741,
 },
 {
 modelNo: 'RN0048-180ml',
 description: '3in1 Crystal Mambo Std. Neck Feeding Bottle with Apple Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 41,
 usd: 0.6074074074074074,
 moq: 3600,
 capacity: '180ml',
 moldNos: 'RN0048',
 monoDimensions: 'L=5.5mm, B=10.2mm, H=15.9mm',
 innerDimensions: 'L=11mm, B=30.6mm, H=31.8mm',
 masterDimensions: 'L=22mm, B=91.8mm, H=63.6mm',
 cbm: 0.1284,
 },
 {
 modelNo: 'RN0048-300ml',
 description: '3in1 Crystal Mambo Std. Neck Feeding Bottle with Apple Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 44,
 usd: 0.6518518518518518,
 moq: 3600,
 capacity: '300ml',
 moldNos: 'RN0048',
 monoDimensions: 'L=5.9mm, B=10.3mm, H=19.9mm',
 innerDimensions: 'L=11.8mm, B=30.9mm, H=39.8mm',
 masterDimensions: 'L=23.6mm, B=92.7mm, H=79.6mm',
 cbm: 0.1741,
 },
 {
 modelNo: 'RN0049-180ml',
 description: 'KK Mambo Std. Neck Feeding Bottle with KK Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 32,
 usd: 0.47407407407407404,
 moq: 3600,
 capacity: '180ml',
 moldNos: 'RN0049',
 },
 {
 modelNo: 'RN0049-300ml',
 description: 'KK Mambo Std. Neck Feeding Bottle with KK Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 35,
 usd: 0.5185185185185185,
 moq: 3600,
 capacity: '300ml',
 moldNos: 'RN0049',
 },
 {
 modelNo: 'RN0050-180ml',
 description: 'Zozo Aqua Std. Neck Feeding Bottle with Rondo Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 35,
 usd: 0.5185185185185185,
 moq: 3600,
 capacity: '180ml',
 moldNos: 'RN0050',
 },
 {
 modelNo: 'RN0050-270ml',
 description: 'Zozo Aqua Std. Neck Feeding Bottle with Rondo Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 38,
 usd: 0.562962962962963,
 moq: 3600,
 capacity: '270ml',
 moldNos: 'RN0050',
 monoDimensions: 'L=5.9mm, B=10.2mm, H=19.8mm',
 innerDimensions: 'L=11.8mm, B=30.6mm, H=39.6mm',
 masterDimensions: 'L=23.6mm, B=91.8mm, H=79.2mm',
 cbm: 0.1715,
 },
 {
 modelNo: 'RN0051-180ml',
 description: 'Zozo + Aqua Std. Neck Feeding Bottle with Zozo+ Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 36,
 usd: 0.5333333333333333,
 moq: 3600,
 capacity: '180ml',
 moldNos: 'RN0051',
 },
 {
 modelNo: 'RN0051-270ml',
 description: 'Zozo + Aqua Std. Neck Feeding Bottle with Zozo+ Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 39,
 usd: 0.5777777777777777,
 moq: 3600,
 capacity: '270ml',
 moldNos: 'RN0051',
 },
 {
 modelNo: 'RN0052-180ml',
 description: 'Slender Aqua Std. Neck Feeding Bottle with Slender Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 35.5,
 usd: 0.5259259259259259,
 moq: 3600,
 capacity: '180ml',
 moldNos: 'RN0052',
 },
 {
 modelNo: 'RN0052-270ml',
 description: 'Slender Aqua Std. Neck Feeding Bottle with Slender Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 38.5,
 usd: 0.5703703703703703,
 moq: 3600,
 capacity: '270ml',
 moldNos: 'RN0052',
 monoDimensions: 'L=5.9mm, B=10.2mm, H=19.8mm',
 innerDimensions: 'L=11.8mm, B=30.6mm, H=39.6mm',
 masterDimensions: 'L=23.6mm, B=91.8mm, H=79.2mm',
 cbm: 0.1715,
 },
 {
 modelNo: 'RN0053-180ml',
 description: '3 Dot Aqua Std. Neck Feeding Bottle with Rondo Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 36.5,
 usd: 0.5407407407407407,
 moq: 3600,
 capacity: '180ml',
 moldNos: 'RN0053',
 },
 {
 modelNo: 'RN0053-270ml',
 description: '3 Dot Aqua Std. Neck Feeding Bottle with Rondo Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 39.5,
 usd: 0.5851851851851851,
 moq: 3600,
 capacity: '270ml',
 moldNos: 'RN0053',
 monoDimensions: 'L=5.9mm, B=10.2mm, H=19.8mm',
 innerDimensions: 'L=11.8mm, B=30.6mm, H=39.6mm',
 masterDimensions: 'L=23.6mm, B=91.8mm, H=79.2mm',
 cbm: 0.1715,
 },
 {
 modelNo: 'RN0054-180ml',
 description: 'Thumb Aqua Std. Neck Feeding Bottle with Apple Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 36,
 usd: 0.5333333333333333,
 moq: 3600,
 capacity: '180ml',
 moldNos: 'RN0054',
 },
 {
 modelNo: 'RN0054-270ml',
 description: 'Thumb Aqua Std. Neck Feeding Bottle with Apple Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 39,
 usd: 0.5777777777777777,
 moq: 3600,
 capacity: '270ml',
 moldNos: 'RN0054',
 monoDimensions: 'L=5.9mm, B=10.2mm, H=19.8mm',
 innerDimensions: 'L=11.8mm, B=30.6mm, H=39.6mm',
 masterDimensions: 'L=23.6mm, B=91.8mm, H=79.2mm',
 cbm: 0.1715,
 },
 {
 modelNo: 'RN0055-180ml',
 description: 'Crystal Aqua Std. Neck Feeding Bottle with Rondo Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 36,
 usd: 0.5333333333333333,
 moq: 3600,
 capacity: '180ml',
 moldNos: 'RN0055',
 },
 {
 modelNo: 'RN0055-270ml',
 description: 'Crystal Aqua Std. Neck Feeding Bottle with Rondo Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 39,
 usd: 0.5777777777777777,
 moq: 3600,
 capacity: '270ml',
 moldNos: 'RN0055',
 monoDimensions: 'L=5.9mm, B=10.2mm, H=19.8mm',
 innerDimensions: 'L=11.8mm, B=30.6mm, H=39.6mm',
 masterDimensions: 'L=23.6mm, B=91.8mm, H=79.2mm',
 cbm: 0.1715,
 },
 {
 modelNo: 'RN0056-180ml',
 description: 'KK Aqua Std. Neck Feeding Bottle with KK Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 34,
 usd: 0.5037037037037037,
 moq: 3600,
 capacity: '180ml',
 moldNos: 'RN0056',
 },
 {
 modelNo: 'RN0056-270ml',
 description: 'KK Aqua Std. Neck Feeding Bottle with KK Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 37,
 usd: 0.5481481481481482,
 moq: 3600,
 capacity: '270ml',
 moldNos: 'RN0056',
 }
 ]
 },
 {
 id: 'wide-feeding',
 name: 'Wide Feeding',
 displayName: 'Wide Neck Feeding Bottles',
 description: 'Premium wide neck feeding bottles with superior design and easy cleaning. Perfect for comfortable feeding experience.',
 image: '/images/Wide Neck Bottles JPEG/WN0001 - 210ml.jpg',
 products: [
 {
 modelNo: 'WN0001-210ml',
 description: 'Natural+ Momo Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 45,
 usd: 0.6666666666666666,
 moq: 3600,
 sNo: 1,
 capacity: '210ml',
 moldNos: 'WN0001',
 monoDimensions: 'L=7.6mm, B=7.6mm, H=15.8mm',
 innerDimensions: 'L=15.2mm, B=22.8mm, H=31.6mm',
 masterDimensions: 'L=30.4mm, B=68.4mm, H=63.2mm',
 cbm: 0.1314,
 },
 {
 modelNo: 'WN0001-240ml',
 description: 'Natural+ Momo Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 48,
 usd: 0.711111111111111,
 moq: 3600,
 sNo: 2,
 capacity: '240ml',
 moldNos: 'WN0001',
 monoDimensions: 'L=7.7mm, B=7.7mm, H=17.5mm',
 innerDimensions: 'L=15.4mm, B=23.1mm, H=35mm',
 masterDimensions: 'L=30.8mm, B=69.3mm, H=70mm',
 cbm: 0.1494,
 },
 {
 modelNo: 'WN0002-210ml',
 description: 'Superflo Momo Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 37,
 usd: 0.548148148148148,
 moq: 3600,
 sNo: 3,
 capacity: '210ml',
 moldNos: 'WN0002',
 monoDimensions: 'L=7.6mm, B=7.6mm, H=15.8mm',
 innerDimensions: 'L=15.2mm, B=22.8mm, H=31.6mm',
 masterDimensions: 'L=30.4mm, B=68.4mm, H=63.2mm',
 cbm: 0.1314,
 },
 {
 modelNo: 'WN0002-240ml',
 description: 'Superflo Momo Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 40,
 usd: 0.5925925925925926,
 moq: 3600,
 sNo: 4,
 capacity: '240ml',
 moldNos: 'WN0002',
 monoDimensions: 'L=7.7mm, B=7.7mm, H=17.5mm',
 innerDimensions: 'L=15.4mm, B=23.1mm, H=35mm',
 masterDimensions: 'L=30.8mm, B=69.3mm, H=70mm',
 cbm: 0.1494,
 },
 {
 modelNo: 'WN0003-210ml',
 description: 'Crystal Wide Momo Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 36.5,
 usd: 0.5407407407407407,
 moq: 3600,
 sNo: 5,
 capacity: '210ml',
 moldNos: 'WN0003',
 monoDimensions: 'L=7.6mm, B=7.6mm, H=16.4mm',
 innerDimensions: 'L=15.2mm, B=22.8mm, H=32.8mm',
 masterDimensions: 'L=30.4mm, B=68.4mm, H=65.6mm',
 cbm: 0.1364,
 },
 {
 modelNo: 'WN0003-240ml',
 description: 'Crystal Wide Momo Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 39.5,
 usd: 0.5851851851851851,
 moq: 3600,
 sNo: 6,
 capacity: '240ml',
 moldNos: 'WN0003',
 monoDimensions: 'L=7.7mm, B=7.7mm, H=18mm',
 innerDimensions: 'L=15.4mm, B=23.1mm, H=36mm',
 masterDimensions: 'L=30.8mm, B=69.3mm, H=72mm',
 cbm: 0.1537,
 },
 {
 modelNo: 'WN0004-210ml',
 description: 'Bullet Momo Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 37,
 usd: 0.548148148148148,
 moq: 3600,
 sNo: 7,
 capacity: '210ml',
 moldNos: 'WN0004',
 monoDimensions: 'L=7.6mm, B=7.6mm, H=16.4mm',
 innerDimensions: 'L=15.2mm, B=22.8mm, H=32.8mm',
 masterDimensions: 'L=30.4mm, B=68.4mm, H=65.6mm',
 cbm: 0.1364,
 },
 {
 modelNo: 'WN0004-240ml',
 description: 'Bullet Momo Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 40,
 usd: 0.5925925925925926,
 moq: 3600,
 sNo: 8,
 capacity: '240ml',
 moldNos: 'WN0004',
 monoDimensions: 'L=7.7mm, B=7.7mm, H=18mm',
 innerDimensions: 'L=15.4mm, B=23.1mm, H=36mm',
 masterDimensions: 'L=30.8mm, B=69.3mm, H=72mm',
 cbm: 0.1537,
 },
 {
 modelNo: 'WN0005-210ml',
 description: 'Natural+ Stylo Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 45,
 usd: 0.6666666666666666,
 moq: 3600,
 sNo: 9,
 capacity: '210ml',
 moldNos: 'WN0005',
 monoDimensions: 'L=8mm, B=8mm, H=14.4mm',
 innerDimensions: 'L=16mm, B=24mm, H=28.8mm',
 masterDimensions: 'L=32mm, B=48mm, H=57.6mm',
 cbm: 0.0885,
 },
 {
 modelNo: 'WN0005-300ml',
 description: 'Natural+ Stylo Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 48,
 usd: 0.711111111111111,
 moq: 3600,
 sNo: 10,
 capacity: '300ml',
 moldNos: 'WN0005',
 monoDimensions: 'L=8.3mm, B=8.3mm, H=15.2mm',
 innerDimensions: 'L=16.6mm, B=24.9mm, H=30.4mm',
 masterDimensions: 'L=33.2mm, B=74.7mm, H=60.8mm',
 cbm: 0.1507,
 },
 {
 modelNo: 'WN0006-210ml',
 description: 'Superflo Stylo Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 38,
 usd: 0.5629629629629629,
 moq: 3600,
 sNo: 11,
 capacity: '210ml',
 moldNos: 'WN0006',
 monoDimensions: 'L=8mm, B=8mm, H=14.4mm',
 innerDimensions: 'L=16mm, B=24mm, H=28.8mm',
 masterDimensions: 'L=32mm, B=48mm, H=57.6mm',
 cbm: 0.0885,
 },
 {
 modelNo: 'WN0006-300ml',
 description: 'Superflo Stylo Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 41,
 usd: 0.6074074074074074,
 moq: 3600,
 sNo: 12,
 capacity: '300ml',
 moldNos: 'WN0006',
 monoDimensions: 'L=8.3mm, B=8.3mm, H=15.2mm',
 innerDimensions: 'L=16.6mm, B=24.9mm, H=30.4mm',
 masterDimensions: 'L=33.2mm, B=74.7mm, H=60.8mm',
 cbm: 0.1507,
 },
 {
 modelNo: 'WN0007-210ml',
 description: 'Crystal Wide Stylo Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 37,
 usd: 0.548148148148148,
 moq: 3600,
 sNo: 13,
 capacity: '210ml',
 moldNos: 'WN0007',
 monoDimensions: 'L=8mm, B=8mm, H=15mm',
 innerDimensions: 'L=16mm, B=24mm, H=30mm',
 masterDimensions: 'L=32mm, B=48mm, H=60mm',
 cbm: 0.0922,
 },
 {
 modelNo: 'WN0007-300ml',
 description: 'Crystal Wide Stylo Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 40,
 usd: 0.5925925925925926,
 moq: 3600,
 sNo: 14,
 capacity: '300ml',
 moldNos: 'WN0007',
 monoDimensions: 'L=8.3mm, B=8.3mm, H=16mm',
 innerDimensions: 'L=16.6mm, B=24.9mm, H=32mm',
 masterDimensions: 'L=33.2mm, B=74.7mm, H=64mm',
 cbm: 0.1586,
 },
 {
 modelNo: 'WN0008-210ml',
 description: 'Bullet Stylo Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 38,
 usd: 0.5629629629629629,
 moq: 3600,
 sNo: 15,
 capacity: '210ml',
 moldNos: 'WN0008',
 monoDimensions: 'L=8mm, B=8mm, H=15mm',
 innerDimensions: 'L=16mm, B=24mm, H=30mm',
 masterDimensions: 'L=32mm, B=48mm, H=60mm',
 cbm: 0.0922,
 },
 {
 modelNo: 'WN0008-300ml',
 description: 'Bullet Stylo Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 41,
 usd: 0.6074074074074074,
 moq: 3600,
 sNo: 16,
 capacity: '300ml',
 moldNos: 'WN0008',
 monoDimensions: 'L=8.3mm, B=8.3mm, H=16mm',
 innerDimensions: 'L=16.6mm, B=24.9mm, H=32mm',
 masterDimensions: 'L=33.2mm, B=74.7mm, H=64mm',
 cbm: 0.1586,
 },
 {
 modelNo: 'WN0009-150ml',
 description: 'Natural+ Dolphin Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 46,
 usd: 0.6814814814814815,
 moq: 3600,
 sNo: 17,
 capacity: '150ml',
 moldNos: 'WN0009',
 monoDimensions: 'L=7.5mm, B=7.5mm, H=14.2mm',
 innerDimensions: 'L=15mm, B=22.5mm, H=28.4mm',
 masterDimensions: 'L=30mm, B=67.5mm, H=56.8mm',
 cbm: 0.115,
 },
 {
 modelNo: 'WN0009-240ml',
 description: 'Natural+ Dolphin Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 49,
 usd: 0.725925925925926,
 moq: 3600,
 sNo: 18,
 capacity: '240ml',
 moldNos: 'WN0009',
 monoDimensions: 'L=7.7mm, B=7.7mm, H=14.6mm',
 innerDimensions: 'L=15.4mm, B=23.1mm, H=29.2mm',
 masterDimensions: 'L=30.8mm, B=69.3mm, H=58.4mm',
 cbm: 0.1246,
 },
 {
 modelNo: 'WN0010-150ml',
 description: 'Superflo Dolphin Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 36,
 usd: 0.5333333333333333,
 moq: 3600,
 sNo: 19,
 capacity: '150ml',
 moldNos: 'WN0010',
 monoDimensions: 'L=7.5mm, B=7.5mm, H=14.2mm',
 innerDimensions: 'L=15mm, B=22.5mm, H=28.4mm',
 masterDimensions: 'L=30mm, B=67.5mm, H=56.8mm',
 cbm: 0.115,
 },
 {
 modelNo: 'WN0010-240ml',
 description: 'Superflo Dolphin Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 39,
 usd: 0.5777777777777777,
 moq: 3600,
 sNo: 20,
 capacity: '240ml',
 moldNos: 'WN0010',
 monoDimensions: 'L=7.7mm, B=7.7mm, H=14.6mm',
 innerDimensions: 'L=15.4mm, B=23.1mm, H=29.2mm',
 masterDimensions: 'L=30.8mm, B=69.3mm, H=58.4mm',
 cbm: 0.1246,
 },
 {
 modelNo: 'WN0011-150ml',
 description: 'Crystal Wide Dolphin Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 37,
 usd: 0.548148148148148,
 moq: 3600,
 sNo: 21,
 capacity: '150ml',
 moldNos: 'WN0011',
 monoDimensions: 'L=7.5mm, B=7.5mm, H=14.9mm',
 innerDimensions: 'L=15mm, B=22.5mm, H=29.8mm',
 masterDimensions: 'L=30mm, B=67.5mm, H=59.6mm',
 cbm: 0.1207,
 },
 {
 modelNo: 'WN0011-240ml',
 description: 'Crystal Wide Dolphin Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 40,
 usd: 0.5925925925925926,
 moq: 3600,
 sNo: 22,
 capacity: '240ml',
 moldNos: 'WN0011',
 monoDimensions: 'L=7.7mm, B=7.7mm, H=15.5mm',
 innerDimensions: 'L=15.4mm, B=23.1mm, H=31mm',
 masterDimensions: 'L=30.8mm, B=69.3mm, H=62mm',
 cbm: 0.1323,
 },
 {
 modelNo: 'WN0012-150ml',
 description: 'Bullet Dolphin Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 37,
 usd: 0.548148148148148,
 moq: 3600,
 sNo: 23,
 capacity: '150ml',
 moldNos: 'WN0012',
 monoDimensions: 'L=7.5mm, B=7.5mm, H=14.9mm',
 innerDimensions: 'L=15mm, B=22.5mm, H=29.8mm',
 masterDimensions: 'L=30mm, B=67.5mm, H=59.6mm',
 cbm: 0.1207,
 },
 {
 modelNo: 'WN0012-240ml',
 description: 'Bullet Dolphin Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 40,
 usd: 0.5925925925925926,
 moq: 3600,
 sNo: 24,
 capacity: '240ml',
 moldNos: 'WN0012',
 monoDimensions: 'L=7.7mm, B=7.7mm, H=15.5mm',
 innerDimensions: 'L=15.4mm, B=23.1mm, H=31mm',
 masterDimensions: 'L=30.8mm, B=69.3mm, H=62mm',
 cbm: 0.1323,
 },
 {
 modelNo: 'WN0013-150ml',
 description: 'Natural+ Bold Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 44,
 usd: 0.6518518518518518,
 moq: 3600,
 sNo: 25,
 capacity: '150ml',
 moldNos: 'WN0013',
 monoDimensions: 'L=7.6mm, B=7.6mm, H=14.5mm',
 innerDimensions: 'L=15.2mm, B=22.8mm, H=29mm',
 masterDimensions: 'L=30.4mm, B=68.4mm, H=58mm',
 cbm: 0.1206,
 },
 {
 modelNo: 'WN0013-210ml',
 description: 'Natural+ Bold Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 49,
 usd: 0.725925925925926,
 moq: 3600,
 sNo: 26,
 capacity: '210ml',
 moldNos: 'WN0013',
 monoDimensions: 'L=7.6mm, B=7.6mm, H=14.8mm',
 innerDimensions: 'L=15.2mm, B=22.8mm, H=29.6mm',
 masterDimensions: 'L=30.4mm, B=68.4mm, H=59.2mm',
 cbm: 0.1231,
 },
 {
 modelNo: 'WN0013-300ml',
 description: 'Natural+ Bold Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 51,
 usd: 0.7555555555555555,
 moq: 3600,
 sNo: 27,
 capacity: '300ml',
 moldNos: 'WN0013',
 monoDimensions: 'L=7.8mm, B=7.8mm, H=17.3mm',
 innerDimensions: 'L=15.6mm, B=23.4mm, H=34.6mm',
 masterDimensions: 'L=31.2mm, B=70.2mm, H=69.2mm',
 cbm: 0.1516,
 },
 {
 modelNo: 'WN0014-150ml',
 description: 'Superflo Bold Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 37,
 usd: 0.548148148148148,
 moq: 3600,
 sNo: 28,
 capacity: '150ml',
 moldNos: 'WN0014',
 monoDimensions: 'L=7.6mm, B=7.6mm, H=14.5mm',
 innerDimensions: 'L=15.2mm, B=22.8mm, H=29mm',
 masterDimensions: 'L=30.4mm, B=68.4mm, H=58mm',
 cbm: 0.1206,
 },
 {
 modelNo: 'WN0014-210ml',
 description: 'Superflo Bold Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 40,
 usd: 0.5925925925925926,
 moq: 3600,
 sNo: 29,
 capacity: '210ml',
 moldNos: 'WN0014',
 monoDimensions: 'L=7.6mm, B=7.6mm, H=14.8mm',
 innerDimensions: 'L=15.2mm, B=22.8mm, H=29.6mm',
 masterDimensions: 'L=30.4mm, B=68.4mm, H=59.2mm',
 cbm: 0.1231,
 },
 {
 modelNo: 'WN0014-300ml',
 description: 'Superflo Bold Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 42,
 usd: 0.6222222222222221,
 moq: 3600,
 sNo: 30,
 capacity: '300ml',
 moldNos: 'WN0014',
 monoDimensions: 'L=7.8mm, B=7.8mm, H=17.3mm',
 innerDimensions: 'L=15.6mm, B=23.4mm, H=34.6mm',
 masterDimensions: 'L=31.2mm, B=70.2mm, H=69.2mm',
 cbm: 0.1516,
 },
 {
 modelNo: 'WN0015-150ml',
 description: 'Crystal Wide Bold Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 38,
 usd: 0.5629629629629629,
 moq: 3600,
 sNo: 31,
 capacity: '150ml',
 moldNos: 'WN0015',
 monoDimensions: 'L=7.6mm, B=7.6mm, H=14.8mm',
 innerDimensions: 'L=15.2mm, B=22.8mm, H=29.6mm',
 masterDimensions: 'L=30.4mm, B=68.4mm, H=59.2mm',
 cbm: 0.1231,
 },
 {
 modelNo: 'WN0015-210ml',
 description: 'Crystal Wide Bold Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 41,
 usd: 0.6074074074074074,
 moq: 3600,
 sNo: 32,
 capacity: '210ml',
 moldNos: 'WN0015',
 monoDimensions: 'L=7.6mm, B=7.6mm, H=15.3mm',
 innerDimensions: 'L=15.2mm, B=22.8mm, H=30.6mm',
 masterDimensions: 'L=30.4mm, B=68.4mm, H=61.2mm',
 cbm: 0.1273,
 },
 {
 modelNo: 'WN0015-300ml',
 description: 'Crystal Wide Bold Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 44,
 usd: 0.6518518518518518,
 moq: 3600,
 sNo: 33,
 capacity: '300ml',
 moldNos: 'WN0015',
 monoDimensions: 'L=7.8mm, B=7.8mm, H=18mm',
 innerDimensions: 'L=15.6mm, B=23.4mm, H=36mm',
 masterDimensions: 'L=31.2mm, B=70.2mm, H=72mm',
 cbm: 0.1577,
 },
 {
 modelNo: 'WN0016-150ml',
 description: 'Bullet Bold Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 38,
 usd: 0.5629629629629629,
 moq: 3600,
 sNo: 34,
 capacity: '150ml',
 moldNos: 'WN0016',
 monoDimensions: 'L=7.6mm, B=7.6mm, H=14.8mm',
 innerDimensions: 'L=15.2mm, B=22.8mm, H=29.6mm',
 masterDimensions: 'L=30.4mm, B=68.4mm, H=59.2mm',
 cbm: 0.1231,
 },
 {
 modelNo: 'WN0016-210ml',
 description: 'Bullet Bold Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 41,
 usd: 0.6074074074074074,
 moq: 3600,
 sNo: 35,
 capacity: '210ml',
 moldNos: 'WN0016',
 monoDimensions: 'L=7.6mm, B=7.6mm, H=15.3mm',
 innerDimensions: 'L=15.2mm, B=22.8mm, H=30.6mm',
 masterDimensions: 'L=30.4mm, B=68.4mm, H=61.2mm',
 cbm: 0.1273,
 },
 {
 modelNo: 'WN0016-300ml',
 description: 'Bullet Bold Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 44,
 usd: 0.6518518518518518,
 moq: 3600,
 sNo: 36,
 capacity: '300ml',
 moldNos: 'WN0016',
 monoDimensions: 'L=7.8mm, B=7.8mm, H=18mm',
 innerDimensions: 'L=15.6mm, B=23.4mm, H=34.6mm',
 masterDimensions: 'L=31.2mm, B=70.2mm, H=72mm',
 cbm: 0.1577,
 },
 {
 modelNo: 'WN0017-180ml',
 description: 'Natural+ Zena Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 44,
 usd: 0.6518518518518518,
 moq: 3600,
 sNo: 37,
 capacity: '180ml',
 moldNos: 'WN0017',
 monoDimensions: 'L=7.5mm, B=7.5mm, H=14.6mm',
 innerDimensions: 'L=15mm, B=22.5mm, H=29.2mm',
 masterDimensions: 'L=30mm, B=67.5mm, H=58.4mm',
 cbm: 0.1183,
 },
 {
 modelNo: 'WN0017-210ml',
 description: 'Natural+ Zena Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 47,
 usd: 0.6962962962962963,
 moq: 3600,
 sNo: 38,
 capacity: '210ml',
 moldNos: 'WN0017',
 monoDimensions: 'L=7.7mm, B=7.7mm, H=17.7mm',
 innerDimensions: 'L=15.4mm, B=23.1mm, H=35.4mm',
 masterDimensions: 'L=30.8mm, B=69.3mm, H=70.8mm',
 cbm: 0.1511,
 },
 {
 modelNo: 'WN0017-300ml',
 description: 'Natural+ Zena Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 50,
 usd: 0.7407407407407407,
 moq: 3600,
 sNo: 39,
 capacity: '300ml',
 moldNos: 'WN0017',
 monoDimensions: 'L=7.7mm, B=7.7mm, H=18mm',
 innerDimensions: 'L=15.4mm, B=23.1mm, H=36mm',
 masterDimensions: 'L=30.8mm, B=69.3mm, H=72mm',
 cbm: 0.153,
 },
 {
 modelNo: 'WN0018-180ml',
 description: 'Superflo Zena Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 37,
 usd: 0.548148148148148,
 moq: 3600,
 sNo: 40,
 capacity: '180ml',
 moldNos: 'WN0018',
 monoDimensions: 'L=7.5mm, B=7.5mm, H=14.6mm',
 innerDimensions: 'L=15mm, B=22.5mm, H=29.2mm',
 masterDimensions: 'L=30mm, B=67.5mm, H=58.4mm',
 cbm: 0.1183,
 },
 {
 modelNo: 'WN0018-210ml',
 description: 'Superflo Zena Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 40,
 usd: 0.5925925925925926,
 moq: 3600,
 sNo: 41,
 capacity: '210ml',
 moldNos: 'WN0018',
 monoDimensions: 'L=7.7mm, B=7.7mm, H=17.7mm',
 innerDimensions: 'L=15.4mm, B=23.1mm, H=35.4mm',
 masterDimensions: 'L=30.8mm, B=69.3mm, H=70.8mm',
 cbm: 0.1511,
 },
 {
 modelNo: 'WN0018-300ml',
 description: 'Superflo Zena Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 42,
 usd: 0.6222222222222221,
 moq: 3600,
 sNo: 42,
 capacity: '300ml',
 moldNos: 'WN0018',
 monoDimensions: 'L=7.7mm, B=7.7mm, H=18mm',
 innerDimensions: 'L=15.4mm, B=23.1mm, H=36mm',
 masterDimensions: 'L=30.8mm, B=69.3mm, H=72mm',
 cbm: 0.153,
 },
 {
 modelNo: 'WN0019-180ml',
 description: 'Crystal Wide Zena Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 38,
 usd: 0.5629629629629629,
 moq: 3600,
 sNo: 43,
 capacity: '180ml',
 moldNos: 'WN0019',
 monoDimensions: 'L=7.5mm, B=7.5mm, H=16mm',
 innerDimensions: 'L=15mm, B=22.5mm, H=32mm',
 masterDimensions: 'L=30mm, B=67.5mm, H=64mm',
 cbm: 0.1296,
 },
 {
 modelNo: 'WN0019-210ml',
 description: 'Crystal Wide Zena Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 41,
 usd: 0.6074074074074074,
 moq: 3600,
 sNo: 44,
 capacity: '210ml',
 moldNos: 'WN0019',
 monoDimensions: 'L=7.7mm, B=7.7mm, H=18.2mm',
 innerDimensions: 'L=15.4mm, B=23.1mm, H=36.4mm',
 masterDimensions: 'L=30.8mm, B=69.3mm, H=72.8mm',
 cbm: 0.1554,
 },
 {
 modelNo: 'WN0019-300ml',
 description: 'Crystal Wide Zena Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 43,
 usd: 0.6370370370370371,
 moq: 3600,
 sNo: 45,
 capacity: '300ml',
 moldNos: 'WN0019',
 monoDimensions: 'L=7.7mm, B=7.7mm, H=19mm',
 innerDimensions: 'L=15.4mm, B=23.1mm, H=38mm',
 masterDimensions: 'L=30.8mm, B=69.3mm, H=76mm',
 cbm: 0.1622,
 },
 {
 modelNo: 'WN0020-180ml',
 description: 'Bullet Zena Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 38,
 usd: 0.5629629629629629,
 moq: 3600,
 sNo: 46,
 capacity: '180ml',
 moldNos: 'WN0020',
 monoDimensions: 'L=7.5mm, B=7.5mm, H=16mm',
 innerDimensions: 'L=15mm, B=22.5mm, H=32mm',
 masterDimensions: 'L=30mm, B=67.5mm, H=64mm',
 cbm: 0.1296,
 },
 {
 modelNo: 'WN0020-210ml',
 description: 'Bullet Zena Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 41,
 usd: 0.6074074074074074,
 moq: 3600,
 sNo: 47,
 capacity: '210ml',
 moldNos: 'WN0020',
 monoDimensions: 'L=7.7mm, B=7.7mm, H=18.2mm',
 innerDimensions: 'L=15.4mm, B=23.1mm, H=36.4mm',
 masterDimensions: 'L=30.8mm, B=69.3mm, H=72.8mm',
 cbm: 0.1554,
 },
 {
 modelNo: 'WN0020-300ml',
 description: 'Bullet Zena Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 43,
 usd: 0.6370370370370371,
 moq: 3600,
 sNo: 48,
 capacity: '300ml',
 moldNos: 'WN0020',
 monoDimensions: 'L=7.7mm, B=7.7mm, H=19mm',
 innerDimensions: 'L=15.4mm, B=23.1mm, H=38mm',
 masterDimensions: 'L=30.8mm, B=69.3mm, H=76mm',
 cbm: 0.1622,
 },
 {
 modelNo: 'WN0021-150ml',
 description: 'Natural+ Zack Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 46,
 usd: 0.6814814814814815,
 moq: 3600,
 sNo: 49,
 capacity: '150ml',
 moldNos: 'WN0021',
 monoDimensions: 'L=7.4mm, B=7.4mm, H=12.8mm',
 innerDimensions: 'L=14.8mm, B=22.2mm, H=25.6mm',
 masterDimensions: 'L=29.6mm, B=66.6mm, H=51.2mm',
 cbm: 0.1009,
 },
 {
 modelNo: 'WN0021-270ml',
 description: 'Natural+ Zack Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 49,
 usd: 0.725925925925926,
 moq: 3600,
 sNo: 50,
 capacity: '270ml',
 moldNos: 'WN0021',
 monoDimensions: 'L=7.9mm, B=7.9mm, H=17.8mm',
 innerDimensions: 'L=15.8mm, B=23.7mm, H=35.6mm',
 masterDimensions: 'L=31.6mm, B=71.1mm, H=71.2mm',
 cbm: 0.16,
 },
 {
 modelNo: 'WN0021-330ml',
 description: 'Natural+ Zack Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 52,
 usd: 0.7703703703703703,
 moq: 3600,
 sNo: 51,
 capacity: '330ml',
 moldNos: 'WN0021',
 monoDimensions: 'L=8.3mm, B=8.3mm, H=18mm',
 innerDimensions: 'L=16.6mm, B=24.9mm, H=36mm',
 masterDimensions: 'L=33.2mm, B=74.7mm, H=72mm',
 cbm: 0.1785,
 },
 {
 modelNo: 'WN0022-150ml',
 description: 'Superflo Zack Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 37,
 usd: 0.548148148148148,
 moq: 3600,
 sNo: 52,
 capacity: '150ml',
 moldNos: 'WN0022',
 monoDimensions: 'L=7.4mm, B=7.4mm, H=12.8mm',
 innerDimensions: 'L=14.8mm, B=22.2mm, H=25.6mm',
 masterDimensions: 'L=29.6mm, B=66.6mm, H=51.2mm',
 cbm: 0.1009,
 },
 {
 modelNo: 'WN0022-270ml',
 description: 'Superflo Zack Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 40,
 usd: 0.5925925925925926,
 moq: 3600,
 sNo: 53,
 capacity: '270ml',
 moldNos: 'WN0022',
 monoDimensions: 'L=7.9mm, B=7.9mm, H=17.8mm',
 innerDimensions: 'L=15.8mm, B=23.7mm, H=35.6mm',
 masterDimensions: 'L=31.6mm, B=71.1mm, H=71.2mm',
 cbm: 0.16,
 },
 {
 modelNo: 'WN0022-330ml',
 description: 'Superflo Zack Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 43,
 usd: 0.6370370370370371,
 moq: 3600,
 sNo: 54,
 capacity: '330ml',
 moldNos: 'WN0022',
 monoDimensions: 'L=8.3mm, B=8.3mm, H=18mm',
 innerDimensions: 'L=16.6mm, B=24.9mm, H=36mm',
 masterDimensions: 'L=33.2mm, B=74.7mm, H=72mm',
 cbm: 0.1785,
 },
 {
 modelNo: 'WN0023-150ml',
 description: 'Crystal Wide Zack Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 38,
 usd: 0.5629629629629629,
 moq: 3600,
 sNo: 55,
 capacity: '150ml',
 moldNos: 'WN0023',
 monoDimensions: 'L=7.4mm, B=7.4mm, H=13.9mm',
 innerDimensions: 'L=14.8mm, B=22.2mm, H=27.8mm',
 masterDimensions: 'L=29.6mm, B=66.6mm, H=55.6mm',
 cbm: 0.1096,
 },
 {
 modelNo: 'WN0023-270ml',
 description: 'Crystal Wide Zack Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 41,
 usd: 0.6074074074074074,
 moq: 3600,
 sNo: 56,
 capacity: '270ml',
 moldNos: 'WN0023',
 monoDimensions: 'L=7.9mm, B=7.9mm, H=18.9mm',
 innerDimensions: 'L=15.8mm, B=23.7mm, H=37.8mm',
 masterDimensions: 'L=31.6mm, B=71.1mm, H=75.6mm',
 cbm: 0,
 },
 {
 modelNo: 'WN0023-330ml',
 description: 'Crystal Wide Zack Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 44,
 usd: 0.6518518518518518,
 moq: 3600,
 sNo: 57,
 capacity: '330ml',
 moldNos: 'WN0023',
 monoDimensions: 'L=8.3mm, B=8.3mm, H=18.9mm',
 innerDimensions: 'L=16.6mm, B=24.9mm, H=37.8mm',
 masterDimensions: 'L=33.2mm, B=74.7mm, H=75.6mm',
 cbm: 0.1875,
 },
 {
 modelNo: 'WN0024-150ml',
 description: 'Bullet Zack Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 38,
 usd: 0.5629629629629629,
 moq: 3600,
 sNo: 58,
 capacity: '150ml',
 moldNos: 'WN0024',
 monoDimensions: 'L=7.4mm, B=7.4mm, H=13.9mm',
 innerDimensions: 'L=14.8mm, B=22.2mm, H=27.8mm',
 masterDimensions: 'L=29.6mm, B=66.6mm, H=55.6mm',
 cbm: 0.1096,
 },
 {
 modelNo: 'WN0024-270ml',
 description: 'Bullet Zack Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 41,
 usd: 0.6074074074074074,
 moq: 3600,
 sNo: 59,
 capacity: '270ml',
 moldNos: 'WN0024',
 monoDimensions: 'L=7.9mm, B=7.9mm, H=18.9mm',
 innerDimensions: 'L=15.8mm, B=23.7mm, H=37.8mm',
 masterDimensions: 'L=31.6mm, B=71.1mm, H=75.6mm',
 cbm: 0.1699,
 },
 {
 modelNo: 'WN0024-330ml',
 description: 'Bullet Zack Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 44,
 usd: 0.6518518518518518,
 moq: 3600,
 sNo: 60,
 capacity: '330ml',
 moldNos: 'WN0024',
 monoDimensions: 'L=8.3mm, B=8.3mm, H=18.9mm',
 innerDimensions: 'L=16.6mm, B=24.9mm, H=37.8mm',
 masterDimensions: 'L=33.2mm, B=74.7mm, H=75.6mm',
 cbm: 0.1875,
 },
 {
 modelNo: 'WN0025-150ml',
 description: 'Natural+ Carlo Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 46,
 usd: 0.6814814814814815,
 moq: 3600,
 sNo: 61,
 capacity: '150ml',
 moldNos: 'WN0025',
 monoDimensions: 'L=7.4mm, B=7.4mm, H=12.8mm',
 innerDimensions: 'L=14.8mm, B=22.2mm, H=25.6mm',
 masterDimensions: 'L=29.6mm, B=66.6mm, H=51.2mm',
 cbm: 0.1009,
 },
 {
 modelNo: 'WN0025-270ml',
 description: 'Natural+ Carlo Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 49,
 usd: 0.725925925925926,
 moq: 3600,
 sNo: 62,
 capacity: '270ml',
 moldNos: 'WN0025',
 monoDimensions: 'L=7.9mm, B=7.9mm, H=17.8mm',
 innerDimensions: 'L=15.8mm, B=23.7mm, H=35.6mm',
 masterDimensions: 'L=31.6mm, B=71.1mm, H=71.2mm',
 cbm: 0.16,
 },
 {
 modelNo: 'WN0026-150ml',
 description: 'Superflo Carlo Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 41,
 usd: 0.6074074074074074,
 moq: 3600,
 sNo: 63,
 capacity: '150ml',
 moldNos: 'WN0026',
 monoDimensions: 'L=7.4mm, B=7.4mm, H=12.8mm',
 innerDimensions: 'L=14.8mm, B=22.2mm, H=25.6mm',
 masterDimensions: 'L=29.6mm, B=66.6mm, H=51.2mm',
 cbm: 0.1009,
 },
 {
 modelNo: 'WN0026-210ml',
 description: 'Superflo Carlo Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 44,
 usd: 0.6518518518518518,
 moq: 3600,
 sNo: 64,
 capacity: '210ml',
 moldNos: 'WN0026',
 monoDimensions: 'L=7.6mm, B=7.6mm, H=15.5mm',
 innerDimensions: 'L=15.2mm, B=22.8mm, H=31mm',
 masterDimensions: 'L=30.4mm, B=68.4mm, H=62mm',
 cbm: 0.129,
 },
 {
 modelNo: 'WN0026-270ml',
 description: 'Superflo Carlo Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 46,
 usd: 0.6814814814814815,
 moq: 3600,
 sNo: 65,
 capacity: '270ml',
 moldNos: 'WN0026',
 monoDimensions: 'L=7.9mm, B=7.9mm, H=17.8mm',
 innerDimensions: 'L=15.8mm, B=23.7mm, H=35.6mm',
 masterDimensions: ', L=31.6mm, B=71.1mm, H=71.2mm',
 cbm: 0.16,
 },
 {
 modelNo: 'WN0027-150ml',
 description: 'Crystal Wide Carlo Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 39,
 usd: 0.5777777777777777,
 moq: 3600,
 sNo: 66,
 capacity: '150ml',
 moldNos: 'WN0027',
 monoDimensions: 'L=7.4mm, B=7.4mm, H=13.9mm',
 innerDimensions: 'L=14.8mm, B=22.2mm, H=27.8mm',
 masterDimensions: 'L=29.6mm, B=66.6mm, H=55.6mm',
 cbm: 0.1096,
 },
 {
 modelNo: 'WN0027-270ml',
 description: 'Crystal Wide Carlo Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 44,
 usd: 0.6518518518518518,
 moq: 3600,
 sNo: 67,
 capacity: '270ml',
 moldNos: 'WN0027',
 monoDimensions: 'L=7.9mm, B=7.9mm, H=18.9mm',
 innerDimensions: 'L=15.8mm, B=23.7mm, H=37.8mm',
 masterDimensions: 'L=31.6mm, B=71.1mm, H=75.6mm',
 cbm: 0.1699,
 },
 {
 modelNo: 'WN0028-150ml',
 description: 'Bullet Carlo Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 39,
 usd: 0.5777777777777777,
 moq: 3600,
 sNo: 68,
 capacity: '150ml',
 moldNos: 'WN0028',
 monoDimensions: 'L=7.4mm, B=7.4mm, H=13.9mm',
 innerDimensions: 'L=14.8mm, B=22.2mm, H=27.8mm',
 masterDimensions: 'L=29.6mm, B=66.6mm, H=55.6mm',
 cbm: 0.1096,
 },
 {
 modelNo: 'WN0028-270ml',
 description: 'Bullet Carlo Wide Neck Feeding Bottle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 44,
 usd: 0.6518518518518518,
 moq: 3600,
 sNo: 69,
 capacity: '270ml',
 moldNos: 'WN0028',
 monoDimensions: 'L=7.9mm, B=7.9mm, H=18.9mm',
 innerDimensions: 'L=15.8mm, B=23.7mm, H=37.8mm',
 masterDimensions: 'L=31.6mm, B=71.1mm, H=75.6mm',
 cbm: 0.1699,
 },
 {
 modelNo: 'WN0029-210ml',
 description: 'Natural+ Momo Wide Neck Feeding Bottle with Curvy Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 55,
 usd: 0.8148148148148148,
 moq: 3600,
 sNo: 70,
 capacity: '210ml',
 moldNos: 'WN0029',
 monoDimensions: 'L=8.1mm, B=11.2mm, H=17.3mm',
 innerDimensions: 'L=16.2mm, B=33.6mm, H=34.6mm',
 masterDimensions: 'L=32.4mm, B=100.8mm, H=69.2mm',
 cbm: 0.226,
 },
 {
 modelNo: 'WN0029-240ml',
 description: 'Natural+ Momo Wide Neck Feeding Bottle with Curvy Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 58,
 usd: 0.8592592592592592,
 moq: 3600,
 sNo: 71,
 capacity: '240ml',
 moldNos: 'WN0029',
 monoDimensions: 'L=8.1mm, B=11.9mm, H=17.9mm',
 innerDimensions: 'L=16.2mm, B=35.7mm, H=35.8mm',
 masterDimensions: 'L=32.4mm, B=107.1mm, H=71.6mm',
 cbm: 0.2484,
 },
 {
 modelNo: 'WN0030-210ml',
 description: 'Superflo Momo Wide Neck Feeding Bottle with Fingergrip Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 46,
 usd: 0.6814814814814815,
 moq: 3600,
 sNo: 72,
 capacity: '210ml',
 moldNos: 'WN0030',
 monoDimensions: 'L=8.1mm, B=11.2mm, H=17.3mm',
 innerDimensions: 'L=16.2mm, B=33.6mm, H=34.6mm',
 masterDimensions: 'L=32.4mm, B=100.8mm, H=69.2mm',
 cbm: 0.226,
 },
 {
 modelNo: 'WN0030-240ml',
 description: 'Superflo Momo Wide Neck Feeding Bottle with Fingergrip Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 49,
 usd: 0.725925925925926,
 moq: 3600,
 sNo: 73,
 capacity: '240ml',
 moldNos: 'WN0030',
 monoDimensions: 'L=8.1mm, B=11.9mm, H=17.9mm',
 innerDimensions: 'L=16.2mm, B=35.7mm, H=35.8mm',
 masterDimensions: 'L=32.4mm, B=107.1mm, H=71.6mm',
 cbm: 0.2484,
 },
 {
 modelNo: 'WN0031-210ml',
 description: 'Crystal Wide Momo Wide Neck Feeding Bottle with Curvy Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 47,
 usd: 0.6962962962962963,
 moq: 3600,
 sNo: 74,
 capacity: '210ml',
 moldNos: 'WN0031',
 monoDimensions: 'L=8.1mm, B=11.2mm, H=18mm',
 innerDimensions: 'L=16.2mm, B=33.6mm, H=36mm',
 masterDimensions: 'L=32.4mm, B=100.8mm, H=72mm',
 cbm: 0.2351,
 },
 {
 modelNo: 'WN0031-240ml',
 description: 'Crystal Wide Momo Wide Neck Feeding Bottle with Curvy Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 50,
 usd: 0.7407407407407407,
 moq: 3600,
 sNo: 75,
 capacity: '240ml',
 moldNos: 'WN0031',
 monoDimensions: 'L=8.1mm, B=11.9mm, H=18.7mm',
 innerDimensions: 'L=16.2mm, B=35.7mm, H=37.4mm',
 masterDimensions: 'L=32.4mm, B=107.1mm, H=74.8mm',
 cbm: 0.2595,
 },
 {
 modelNo: 'WN0032-210ml',
 description: 'Bullet Momo Wide Neck Feeding Bottle with 2tone Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 52,
 usd: 0.7703703703703703,
 moq: 3600,
 sNo: 76,
 capacity: '210ml',
 moldNos: 'WN0032',
 monoDimensions: 'L=8.16mm, B=11.2mm, H=18mm',
 innerDimensions: 'L=16.2mm, B=33.6mm, H=36mm',
 masterDimensions: 'L=32.4mm, B=100.8mm, H=72mm',
 cbm: 0.2351,
 },
 {
 modelNo: 'WN0032-240ml',
 description: 'Bullet Momo Wide Neck Feeding Bottle with 2tone Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 55,
 usd: 0.8148148148148148,
 moq: 3600,
 sNo: 77,
 capacity: '240ml',
 moldNos: 'WN0032',
 monoDimensions: 'L=8.1mm, B=11.9mm, H=18.7mm',
 innerDimensions: 'L=16.2mm, B=35.7mm, H=37.4mm',
 masterDimensions: 'L=32.4mm, B=107.1mm, H=74.8mm',
 cbm: 0.2595,
 },
 {
 modelNo: 'WN0033-150ml',
 description: 'Superflo Bold Wide Neck Feeding Bottle with Fingergrip Hanlde',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 46,
 usd: 0.6814814814814815,
 moq: 3600,
 sNo: 78,
 capacity: '150ml',
 moldNos: 'WN0033',
 monoDimensions: 'L=8.2mm, B=11.4mm, H=15.7mm',
 innerDimensions: 'L=16.4mm, B=34.2mm, H=31.4mm',
 masterDimensions: 'L=32.8mm, B=102.6mm, H=62.8mm',
 cbm: 0.2114,
 },
 {
 modelNo: 'WN0033-210ml',
 description: 'Superflo Bold Wide Neck Feeding Bottle with Fingergrip Hanlde',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 48,
 usd: 0.711111111111111,
 moq: 3600,
 sNo: 79,
 capacity: '210ml',
 moldNos: 'WN0033',
 monoDimensions: 'L=8.2mm, B=11.4mm, H=18.7mm',
 innerDimensions: 'L=16.4mm, B=34.2mm, H=37.4mm',
 masterDimensions: 'L=32.8mm, B=102.6mm, H=74.8mm',
 cbm: 0.2519,
 },
 {
 modelNo: 'WN0033-300ml',
 description: 'Superflo Bold Wide Neck Feeding Bottle with Fingergrip Hanlde',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 51,
 usd: 0.7555555555555555,
 moq: 3600,
 sNo: 80,
 capacity: '300ml',
 moldNos: 'WN0033',
 monoDimensions: 'L=8.2mm, B=11.4mm, H=19.4mm',
 innerDimensions: 'L=16.4mm, B=34.2mm, H=38.8mm',
 masterDimensions: 'L=32.8mm, B=102.6mm, H=77.6mm',
 cbm: 0.2612,
 },
 {
 modelNo: 'WN0034-150ml',
 description: 'Crystal Wide Bold Wide Neck Feeding Bottle with Curvy Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 47,
 usd: 0.6962962962962963,
 moq: 3600,
 sNo: 81,
 capacity: '150ml',
 moldNos: 'WN0034',
 monoDimensions: 'L=8.2mm, B=11.4mm, H=15.7mm',
 innerDimensions: 'L=16.4mm, B=34.2mm, H=31.4mm',
 masterDimensions: 'L=32.8mm, B=102.6mm, H=62.8mm',
 cbm: 0.2114,
 },
 {
 modelNo: 'WN0034-210ml',
 description: 'Crystal Wide Bold Wide Neck Feeding Bottle with Curvy Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 50,
 usd: 0.7407407407407407,
 moq: 3600,
 sNo: 82,
 capacity: '210ml',
 moldNos: 'WN0034',
 monoDimensions: 'L=8.2mm, B=11.4mm, H=18.7mm',
 innerDimensions: 'L=16.4mm, B=34.2mm, H=37.4mm',
 masterDimensions: 'L=32.8mm, B=102.6mm, H=74.8mm',
 cbm: 0.2519,
 },
 {
 modelNo: 'WN0034-300ml',
 description: 'Crystal Wide Bold Wide Neck Feeding Bottle with Curvy Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 53,
 usd: 0.7851851851851852,
 moq: 3600,
 sNo: 83,
 capacity: '300ml',
 moldNos: 'WN0034',
 monoDimensions: 'L=8.2mm, B=11.4mm, H=19.4mm',
 innerDimensions: 'L=16.4mm, B=34.2mm, H=38.8mm',
 masterDimensions: 'L=32.8m, B=102.6mm, H=77.6mm',
 cbm: 0.2612,
 },
 {
 modelNo: 'WN0035-150ml',
 description: 'Bullet Bold Wide Neck Feeding Bottle with Fingergrip Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 46,
 usd: 0.6814814814814815,
 moq: 3600,
 sNo: 84,
 capacity: '150ml',
 moldNos: 'WN0035',
 monoDimensions: 'L=8.2mm, B=11.4mm, H=15.7mm',
 innerDimensions: 'L=16.4mm, B=34.2mm, H=31.4mm',
 masterDimensions: 'L=32.8mm, B=102.6mm, H=62.8mm',
 cbm: 0.2114,
 },
 {
 modelNo: 'WN0035-210ml',
 description: 'Bullet Bold Wide Neck Feeding Bottle with Fingergrip Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 49,
 usd: 0.725925925925926,
 moq: 3600,
 sNo: 85,
 capacity: '210ml',
 moldNos: 'WN0035',
 monoDimensions: 'L=8.2mm, B=11.4mm, H=18.7mm',
 innerDimensions: 'L=16.4mm, B=34.2mm, H=37.4mm',
 masterDimensions: 'L=32.8mm, B=102.6mm, H=74.8mm',
 cbm: 0.2519,
 },
 {
 modelNo: 'WN0035-300ml',
 description: 'Bullet Bold Wide Neck Feeding Bottle with Fingergrip Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 52,
 usd: 0.7703703703703703,
 moq: 3600,
 sNo: 86,
 capacity: '300ml',
 moldNos: 'WN0035',
 monoDimensions: 'L=8.2mm, B=11.4mm, H=19.4mm',
 innerDimensions: 'L=16.4mm, B=34.2mm, H=38.8mm',
 masterDimensions: 'L=32.8mm, B=102.6mm, H=77.6mm',
 cbm: 0.2612,
 },
 {
 modelNo: 'WN0036-150ml',
 description: 'Superflo Carlo Wide Neck Feeding Bottle with Fingergrip Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 50,
 usd: 0.7407407407407407,
 moq: 3600,
 sNo: 87,
 capacity: '150ml',
 moldNos: 'WN0036',
 monoDimensions: 'L=8.2mm, B=11.3mm, H=15mm',
 innerDimensions: 'L=16.4mm, B=33.9mm, H=30mm',
 masterDimensions: 'L=32.8mm, B=101.7mm, H=60mm',
 cbm: 0.2001,
 },
 {
 modelNo: 'WN0036-210ml',
 description: 'Superflo Carlo Wide Neck Feeding Bottle with Fingergrip Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 53,
 usd: 0.7851851851851852,
 moq: 3600,
 sNo: 88,
 capacity: '210ml',
 moldNos: 'WN0036',
 monoDimensions: 'L=8.2mm, B=11.3mm, H=15.6mm',
 innerDimensions: 'L=16.4mm, B=33.9mm, H=31.2mm',
 masterDimensions: 'L=32.8mm, B=101.7mm, H=62.4mm',
 cbm: 0.2081,
 },
 {
 modelNo: 'WN0036-270ml',
 description: 'Superflo Carlo Wide Neck Feeding Bottle with Fingergrip Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 55,
 usd: 0.8148148148148148,
 moq: 3600,
 sNo: 89,
 capacity: '270ml',
 moldNos: 'WN0036',
 monoDimensions: 'L=8.1mm, B=11mm, H=18.4mm',
 innerDimensions: 'L=16.2mm, B=33mm, H=36.8mm',
 masterDimensions: 'L=32.4mm, B=99mm, H=73.6mm',
 cbm: 0.2455,
 },
 {
 modelNo: 'WN0037-150ml',
 description: 'Crystal Wide Carlo Wide Neck Feeding Bottle with Curvy Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 49,
 usd: 0.725925925925926,
 moq: 3600,
 sNo: 90,
 capacity: '150ml',
 moldNos: 'WN0037',
 monoDimensions: 'L=8.2mm, B=11.3mm, H=15mm',
 innerDimensions: 'L=16.4mm, B=33.9mm, H=30mm',
 masterDimensions: 'L=32.8mm, B=101.7mm, H=60mm',
 cbm: 0.2001,
 },
 {
 modelNo: 'WN0037-210ml',
 description: 'Crystal Wide Carlo Wide Neck Feeding Bottle with Curvy Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 52,
 usd: 0.7703703703703703,
 moq: 3600,
 sNo: 91,
 capacity: '210ml',
 moldNos: 'WN0037',
 monoDimensions: 'L=8.2mm, B=11.3mm, H=15.6mm',
 innerDimensions: 'L=16.4mm, B=33.9mm, H=31.2mm',
 masterDimensions: 'L=32.8mm, B=101.7mm, H=62.4mm',
 cbm: 0.2081,
 },
 {
 modelNo: 'WN0037-270ml',
 description: 'Crystal Wide Carlo Wide Neck Feeding Bottle with Curvy Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 55,
 usd: 0.8148148148148148,
 moq: 3600,
 sNo: 92,
 capacity: '270ml',
 moldNos: 'WN0037',
 monoDimensions: 'L=8.1mm, B=11mm, H=18.4mm',
 innerDimensions: 'L=16.2mm, B=33mm, H=36.8mm',
 masterDimensions: 'L=32.4m, B=99mm, H=73.6mm',
 cbm: 0.2455,
 },
 {
 modelNo: 'WN0038-150ml',
 description: 'Bullet Carlo Wide Neck Feeding Bottle with Fingergrip Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 49,
 usd: 0.725925925925926,
 moq: 3600,
 sNo: 93,
 capacity: '150ml',
 moldNos: 'WN0038',
 monoDimensions: 'L=8.2mm, B=11.3mm, H=15mm',
 innerDimensions: 'L=16.4mm, B=33.9mm, H=30mm',
 masterDimensions: 'L=32.8mm, B=101.7mm, H=60mm',
 cbm: 0.2001,
 },
 {
 modelNo: 'WN0038-210ml',
 description: 'Bullet Carlo Wide Neck Feeding Bottle with Fingergrip Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 52,
 usd: 0.7703703703703703,
 moq: 3600,
 sNo: 94,
 capacity: '210ml',
 moldNos: 'WN0038',
 monoDimensions: 'L=8.2mm, B=11.3mm, H=15.6mm',
 innerDimensions: 'L=16.4mm, B=33.9mm, H=31.2mm',
 masterDimensions: 'L=32.8mm, B=101.7mm, H=62.4mm',
 cbm: 0.2081,
 },
 {
 modelNo: 'WN0038-270ml',
 description: 'Bullet Carlo Wide Neck Feeding Bottle with Fingergrip Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 55,
 usd: 0.8148148148148148,
 moq: 3600,
 sNo: 95,
 capacity: '270ml',
 moldNos: 'WN0038',
 monoDimensions: 'L=8.1mm, B=11mm, H=18.4mm',
 innerDimensions: 'L=16.2mm, B=33mm, H=36.8mm',
 masterDimensions: 'L=32.4mm, B=99mm, H=73.6mm',
 cbm: 0.2455,
 },
 {
 modelNo: 'WN0039-150ml',
 description: 'Natural+ Dolphin Wide Neck Feeding Bottle with Curvy Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 55,
 usd: 0.8148148148148148,
 moq: 3600,
 sNo: 96,
 capacity: '150ml',
 moldNos: 'WN0039',
 monoDimensions: 'L=8.4mm, B=11.2mm, H=14.8mm',
 innerDimensions: 'L=16.8mm, B=33.6mm, H=29.6mm',
 masterDimensions: 'L=33.6mm, B=100.8mm, H=59.2mm',
 cbm: 0.2005,
 },
 {
 modelNo: 'WN0039-240ml',
 description: 'Natural+ Dolphin Wide Neck Feeding Bottle with Curvy Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 58,
 usd: 0.8592592592592592,
 moq: 3600,
 sNo: 97,
 capacity: '240ml',
 moldNos: 'WN0039',
 monoDimensions: 'L=8.5mm, B=11.2mm, H=17.2mm',
 innerDimensions: 'L=17mm, B=33.6mm, H=34.4mm',
 masterDimensions: 'L=34mm, B=100.8mm, H=68.8mm',
 cbm: 0.2358,
 },
 {
 modelNo: 'WN0040-150ml',
 description: 'Superflo Dolphin Wide Neck Feeding Bottle with Fingergrip Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 46,
 usd: 0.6814814814814815,
 moq: 3600,
 sNo: 98,
 capacity: '150ml',
 moldNos: 'WN0040',
 monoDimensions: 'L=8.4mm, B=11.2mm, H=14.8mm',
 innerDimensions: 'L=16.8mm, B=33.6mm, H=29.6mm',
 masterDimensions: 'L=33.6mm, B=100.8mm, H=59.2mm',
 cbm: 0.2005,
 },
 {
 modelNo: 'WN0040-240ml',
 description: 'Superflo Dolphin Wide Neck Feeding Bottle with Fingergrip Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 49,
 usd: 0.725925925925926,
 moq: 3600,
 sNo: 99,
 capacity: '240ml',
 moldNos: 'WN0040',
 monoDimensions: 'L=8.5mm, B=11.2mm, H=17.2mm',
 innerDimensions: 'L=17mm, B=33.6mm, H=34.4mm',
 masterDimensions: 'L=34mm, B=100.8mm, H=68.8mm',
 cbm: 0.2358,
 },
 {
 modelNo: 'WN0041-150ml',
 description: 'Crystal Wide Dolphin Wide Neck Feeding Bottle with Curvy Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 47,
 usd: 0.6962962962962963,
 moq: 3600,
 sNo: 100,
 capacity: '150ml',
 moldNos: 'WN0041',
 monoDimensions: 'L=8.4mm, B=11.2mm, H=14.8mm',
 innerDimensions: 'L=16.8mm, B=33.6mm, H=29.6mm',
 masterDimensions: 'L=33.6mm, B=100.8mm, H=59.2mm',
 cbm: 0.2005,
 },
 {
 modelNo: 'WN0041-240ml',
 description: 'Crystal Wide Dolphin Wide Neck Feeding Bottle with Curvy Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 50,
 usd: 0.7407407407407407,
 moq: 3600,
 sNo: 101,
 capacity: '240ml',
 moldNos: 'WN0041',
 monoDimensions: 'L=8.5mm, B=11.2mm, H=17.2mm',
 innerDimensions: 'L=17mm, B=33.6mm, H=34.4mm',
 masterDimensions: 'L=34mm, B=100.8mm, H=68.8mm',
 cbm: 0.2358,
 },
 {
 modelNo: 'WN0042-150ml',
 description: 'Bullet Dolphin Wide Neck Feeding Bottle with 2tone Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 52,
 usd: 0.7703703703703703,
 moq: 3600,
 sNo: 102,
 capacity: '150ml',
 moldNos: 'WN0042',
 monoDimensions: 'L=8.4mm, B=11.2mm, H=14.8mm',
 innerDimensions: 'L=16.8mm, B=33.6mm, H=29.6mm',
 masterDimensions: 'L=33.6mm, B=100.8mm, H=59.2mm',
 cbm: 0.2005,
 },
 {
 modelNo: 'WN0042-240ml',
 description: 'Bullet Dolphin Wide Neck Feeding Bottle with 2tone Handle',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 55,
 usd: 0.8148148148148148,
 moq: 3600,
 sNo: 103,
 capacity: '240ml',
 moldNos: 'WN0042',
 monoDimensions: 'L=8.5mm, B=11.2mm, H=17.2mm',
 innerDimensions: 'L=17mm, B=33.6mm, H=34.4mm',
 masterDimensions: 'L=34mm, B=100.8mm, H=68.8mm',
 cbm: 0.2358,
 },
 {
 modelNo: 'WN0043',
 description: 'LSR Wide Neck Feeding Bottle - Big',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 115,
 usd: 1.7037037037037037,
 moq: 3600,
 sNo: 104,
 moldNos: 'WN0043',
 monoDimensions: 'L=8.1mm, B=11.8mm, H=16.8mm',
 innerDimensions: 'L=16.2mm, B=35.4mm, H=33.6mm',
 masterDimensions: 'L=32.4mm, B=106.2mm, H=67.2mm',
 cbm: 0.2313,
 },
 {
 modelNo: 'WN0044',
 description: 'LSR Wide Neck Feeding Bottle - Small',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 105,
 usd: 1.5555555555555556,
 moq: 3600,
 sNo: 105,
 moldNos: 'WN0044',
 monoDimensions: 'L=8.1mm, B=11.8mm, H=18.1mm',
 innerDimensions: 'L=16.2mm, B=35.4mm, H=36.2mm',
 masterDimensions: 'L=32.4mm, B=106.2mm, H=72.4mm',
 cbm: 0.249,
 }
 ]
 },
 {
 id: 'sippy-cups',
 name: 'Sippy Cups',
 displayName: 'Sippy Cups & Training Cups',
 description: 'Transition cups for toddlers with spill-proof design and various capacity options. Perfect for developing independence.',
 image: '/images/Sippy Cups JPEG/SP0001 - 150ml.jpg',
 products: [
 {
 modelNo: 'SP0001',
 description: 'Dolphin Sippy Cup with Soft Spout - 150ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 51,
 usd: 0.6296296296296297,
 moq: 3600,
 monoDimensions: 'L=8mm, B=11.6mm, H=14.5mm',
 innerDimensions: 'L=16mm, B=34.8mm, H=29mm',
 cbm: 0.1937,
 },
 {
 modelNo: 'SP0002',
 description: 'Dolphin Sippy Cup with Soft Spout - 240ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 56,
 usd: 0.691358024691358,
 moq: 3600,
 monoDimensions: 'L=8mm, B=11.6mm, H=16m',
 innerDimensions: 'L=16mm, B=38.4mm, H=32mm',
 cbm: 0.214,
 },
 {
 modelNo: 'SP0003',
 description: 'Trendy Sippy Cup - Hard Spout - 200ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 42,
 usd: 0.5185185185185185,
 moq: 3600,
 monoDimensions: 'L=9.1mm, B=10.2mm, H=11.2mm',
 innerDimensions: 'L=18.2mm, B=30.6mm, H=22.4mm',
 cbm: 0.1497,
 },
 {
 modelNo: 'SP0004',
 description: 'Cowboy Hard Spout Sipper - 300ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 67,
 usd: 0.8271604938271605,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=17mm',
 innerDimensions: 'L=16mm, B=30mm, H=34mm',
 cbm: 0.196,
 },
 {
 modelNo: 'SP0005',
 description: 'Cowboy Hard Spout Sipper - 200ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 62,
 usd: 0.7654320987654321,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=14.7mm',
 innerDimensions: 'L=16mm, B=30mm, H=29.4mm',
 cbm: 0.169,
 },
 {
 modelNo: 'SP0006',
 description: 'Cowboy Straw Sipper - 300ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 65,
 usd: 0.8024691358024691,
 moq: 3600,
 monoDimensions: 'L=8mm, B=8mm, H=17mm',
 innerDimensions: 'L=16mm, B=24mm, H=34mm',
 cbm: 0.0011,
 },
 {
 modelNo: 'SP0007',
 description: 'Cowboy Straw Sipper - 200ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 61,
 usd: 0.7530864197530864,
 moq: 3600,
 monoDimensions: 'L=8mm, B=8mm, H=14.7mm',
 innerDimensions: 'L=16mm, B=24mm, H=29.4mm',
 cbm: 0.00094,
 },
 {
 modelNo: 'SP0008',
 description: 'Rivera Straw Sipper with Hanger - 350ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 65,
 usd: 0.8024691358024691,
 moq: 3600,
 monoDimensions: 'L=8mm, B=9.9mm, H=22mm',
 innerDimensions: 'L=16mm, B=29.7mm, H=44mm',
 cbm: 0.2508,
 },
 {
 modelNo: 'SP0009',
 description: 'Rio Sipper with Soft Spout - 180ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 55,
 usd: 0.6790123456790124,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=14.7mm',
 innerDimensions: 'L=16mm, B=30mm, H=29.4mm',
 cbm: 0.169,
 },
 {
 modelNo: 'SP0010',
 description: 'Rio Sipper with Hard Spout - 180ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 48,
 usd: 0.5925925925925926,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=14.7mm',
 innerDimensions: 'L=16mm, B=30mm, H=29.4mm',
 cbm: 0.169,
 },
 {
 modelNo: 'SP0011',
 description: 'Rio Straw Sipper Rotate - 180ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 53,
 usd: 0.654320987654321,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=14.7mm',
 innerDimensions: 'L=16mm, B=30mm, H=29.4mm',
 cbm: 0.169,
 },
 {
 modelNo: 'SP0012',
 description: 'Rio Duck Straw Sipper - 180ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 54,
 usd: 0.6666666666666666,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=14.7mm',
 innerDimensions: 'L=16mm, B=30mm, H=29.4mm',
 cbm: 0.169,
 },
 {
 modelNo: 'SP0013',
 description: 'Rio 360 Sipper - 180ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 50,
 usd: 0.6172839506172839,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=14.7mm',
 innerDimensions: 'L=16mm, B=30mm, H=29.4mm',
 cbm: 0.169,
 },
 {
 modelNo: 'SP0014',
 description: 'Rio Straw Sipper Flip Style - 180ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 52,
 usd: 0.6419753086419753,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=14.7mm',
 innerDimensions: 'L=16mm, B=30mm, H=29.4mm',
 cbm: 0.169,
 },
 {
 modelNo: 'SP0015',
 description: 'Bummer Handle Dolphin Straw Sipper - 200ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 60,
 usd: 0.7407407407407407,
 moq: 3600,
 monoDimensions: 'L=8mm, B=11.6mm, H=17mm',
 innerDimensions: 'L=16mm, B=34.8mm, H=34mm',
 cbm: 0.2272,
 },
 {
 modelNo: 'SP0016',
 description: 'Bummer Handle Soft Spout Sipper - 200ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 65,
 usd: 0.8024691358024691,
 moq: 3600,
 monoDimensions: 'L=8mm, B=11.6mm, H=17mm',
 innerDimensions: 'L=16mm, B=34.8mm, H=34mm',
 cbm: 0.2272,
 },
 {
 modelNo: 'SP0017',
 description: 'Bummer Handle Hard Spout Sipper - 200ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 60,
 usd: 0.7407407407407407,
 moq: 3600,
 monoDimensions: 'L=8mm, B=11.6mm, H=17mm',
 innerDimensions: 'L=16mm, B=34.8mm, H=34mm',
 cbm: 0.2272,
 },
 {
 modelNo: 'SP0018',
 description: 'Bummer Handle Flip Straw Sipper - 200ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 62,
 usd: 0.7654320987654321,
 moq: 3600,
 monoDimensions: 'L=8mm, B=11.6mm, H=17mm',
 innerDimensions: 'L=16mm, B=34.8mm, H=34mm',
 cbm: 0.2272,
 },
 {
 modelNo: 'SP0019',
 description: 'Bummer Handle Rotate Straw Sipper - 200ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 65,
 usd: 0.8024691358024691,
 moq: 3600,
 monoDimensions: 'L=8mm, B=11.6mm, H=17mm',
 innerDimensions: 'L=16mm, B=34.8mm, H=34mm',
 cbm: 0.2272,
 },
 {
 modelNo: 'SP0020',
 description: 'Bummer Handle 360 Cup - 200ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 60,
 usd: 0.7407407407407407,
 moq: 3600,
 monoDimensions: 'L=8mm, B=11.6mm, H=17mm',
 innerDimensions: 'L=16mm, B=34.8mm, H=34mm',
 cbm: 0.2272,
 },
 {
 modelNo: 'SP0021',
 description: 'Bunty Sipper with Duck Straw - 180ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 65,
 usd: 0.8024691358024691,
 moq: 3600,
 monoDimensions: 'L=8mm, B=11.6mm, H=17mm',
 innerDimensions: 'L=16mm, B=34.8mm, H=34mm',
 cbm: 0.2272,
 },
 {
 modelNo: 'SP0022',
 description: 'Bunty Sipper with Slip Straw - 180ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 65,
 usd: 0.8024691358024691,
 moq: 3600,
 monoDimensions: 'L=8mm, B=11.6mm, H=17mm',
 innerDimensions: 'L=16mm, B=34.8mm, H=34mm',
 cbm: 0.2272,
 },
 {
 modelNo: 'SP0023',
 description: 'Bunty Sipper with Trix Straw - 180ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 65,
 usd: 0.8024691358024691,
 moq: 3600,
 monoDimensions: 'L=8mm, B=11.6mm, H=17mm',
 innerDimensions: 'L=16mm, B=34.8mm, H=34mm',
 cbm: 0.2272,
 },
 {
 modelNo: 'SP0024',
 description: 'Bunty Handle Soft Spout Sipper - 180ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 70,
 usd: 0.8641975308641975,
 moq: 3600,
 monoDimensions: 'L=8mm, B=11.6mm, H=17mm',
 innerDimensions: 'L=16mm, B=34.8mm, H=34mm',
 cbm: 0.2272,
 },
 {
 modelNo: 'SP0025',
 description: 'Sport Sipper - Soft Spout - 300ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 65,
 usd: 0.8024691358024691,
 moq: 3600,
 monoDimensions: 'L=8mm, B=8mm, H=20mm',
 innerDimensions: 'L=16mm, B=24mm, H=40mm',
 cbm: 0.1843,
 },
 {
 modelNo: 'SP0026',
 description: 'Sport Sipper - Hard Spout - 300ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 60,
 usd: 0.7407407407407407,
 moq: 3600,
 monoDimensions: 'L=8mm, B=8mm, H=20mm',
 innerDimensions: 'L=16mm, B=24mm, H=40mm',
 cbm: 0.1843,
 },
 {
 modelNo: 'SP0027',
 description: 'Sport Sipper - Duck Straw - 300ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 62,
 usd: 0.7654320987654321,
 moq: 3600,
 monoDimensions: 'L=8mm, B=8mm, H=20mm',
 innerDimensions: 'L=16mm, B=24mm, H=40mm',
 cbm: 0.1843,
 },
 {
 modelNo: 'SP0028',
 description: 'Sport Sipper - Flip Straw - 300ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 63,
 usd: 0.7777777777777778,
 moq: 3600,
 monoDimensions: 'L=8mm, B=8mm, H=20mm',
 innerDimensions: 'L=16mm, B=24mm, H=40mm',
 cbm: 0.1843,
 },
 {
 modelNo: 'SP0029',
 description: 'Sport Sipper - Rotate Straw - 300ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 65,
 usd: 0.8024691358024691,
 moq: 3600,
 monoDimensions: 'L=8mm, B=8mm, H=20mm',
 innerDimensions: 'L=16mm, B=24mm, H=40mm',
 cbm: 0.1843,
 },
 {
 modelNo: 'SP0030',
 description: 'Sport Sipper - 360 Cup - 300ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 60,
 usd: 0.7407407407407407,
 moq: 3600,
 monoDimensions: 'L=8mm, B=8mm, H=20mm',
 innerDimensions: 'L=16mm, B=24mm, H=40mm',
 cbm: 0.1843,
 },
 {
 modelNo: 'SP0031',
 description: 'Bozo Sipper - Soft Spout - 300ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 65,
 usd: 0.8024691358024691,
 moq: 3600,
 monoDimensions: 'L=8mm, B=9mm, H=17.5mm',
 innerDimensions: 'L=16mm, B=27mm, H=35mm',
 cbm: 0.1814,
 },
 {
 modelNo: 'SP0032',
 description: 'Bozo Sipper - Hard Spout - 300ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 60,
 usd: 0.7407407407407407,
 moq: 3600,
 monoDimensions: 'L=8mm, B=9mm, H=17.5mm',
 innerDimensions: 'L=16mm, B=27mm, H=35mm',
 cbm: 0.1814,
 },
 {
 modelNo: 'SP0033',
 description: 'Bozo Sipper - Duck Straw - 300ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 62,
 usd: 0.7654320987654321,
 moq: 3600,
 monoDimensions: 'L=8mm, B=9mm, H=17.5mm',
 innerDimensions: 'L=16mm, B=27mm, H=35mm',
 cbm: 0.1814,
 },
 {
 modelNo: 'SP0034',
 description: 'Bozo Sipper - Flip Straw - 300ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 63,
 usd: 0.7777777777777778,
 moq: 3600,
 monoDimensions: 'L=8mm, B=9mm, H=17.5mm',
 innerDimensions: 'L=16mm, B=27mm, H=35mm',
 cbm: 0.1814,
 },
 {
 modelNo: 'SP0035',
 description: 'Bozo Sipper - Rotate Sipper - 300ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 65,
 usd: 0.8024691358024691,
 moq: 3600,
 monoDimensions: 'L=8mm, B=9mm, H=17.5mm',
 innerDimensions: 'L=16mm, B=27mm, H=35mm',
 cbm: 0.1814,
 },
 {
 modelNo: 'SP0036',
 description: 'Bozo Sipper - 360 Cup - 300ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 60,
 usd: 0.7407407407407407,
 moq: 3600,
 monoDimensions: 'L=8mm, B=9mm, H=17.5mm',
 innerDimensions: 'L=16mm, B=27mm, H=35mm',
 cbm: 0.1814,
 },
 {
 modelNo: 'SP0037',
 description: 'Momo Sipper - Soft Spout - 240ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 65,
 usd: 0.8024691358024691,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=18.5mm',
 innerDimensions: 'L=16mm, B=30mm, H=37mm',
 cbm: 0.213,
 },
 {
 modelNo: 'SP0038',
 description: 'Momo Sipper - Soft Spout - 210ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 60,
 usd: 0.7407407407407407,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=17mm',
 innerDimensions: 'L=16mm, B=30mm, H=34mm',
 cbm: 0.196,
 },
 {
 modelNo: 'SP0039',
 description: 'Trix Straw Sipper - 240ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 62,
 usd: 0.7654320987654321,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=17mm',
 innerDimensions: 'L=16mm, B=30mm, H=34mm',
 cbm: 0.196,
 },
 {
 modelNo: 'SP0040',
 description: 'Trix Straw Sipper - 150ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 58,
 usd: 0.7160493827160493,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=14.7mm',
 innerDimensions: 'L=16mm, B=30mm, H=29.4mm',
 cbm: 0.169,
 },
 {
 modelNo: 'SP0041',
 description: 'Trix Stylo Straw Sipper - 300ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 65,
 usd: 0.8024691358024691,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=17mm',
 innerDimensions: 'L=16mm, B=30mm, H=34mm',
 cbm: 0.196,
 },
 {
 modelNo: 'SP0042',
 description: 'Trix Stylo Straw Sipper - 210ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 60,
 usd: 0.7407407407407407,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=14.7mm',
 innerDimensions: 'L=16mm, B=30mm, H=29.4mm',
 cbm: 0.169,
 },
 {
 modelNo: 'SP0043',
 description: 'Trix Zack Straw Sipper - 330ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 65,
 usd: 0.8024691358024691,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=17mm',
 innerDimensions: 'L=16mm, B=30mm, H=34mm',
 cbm: 0.196,
 },
 {
 modelNo: 'SP0044',
 description: 'Trix Zack Straw Sipper - 270ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 62,
 usd: 0.7654320987654321,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=17mm',
 innerDimensions: 'L=16mm, B=30mm, H=34mm',
 cbm: 0.196,
 },
 {
 modelNo: 'SP0045',
 description: 'Trix Carlo Straw Sipper - 270ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 65,
 usd: 0.8024691358024691,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=17mm',
 innerDimensions: 'L=16mm, B=30mm, H=34mm',
 cbm: 0.196,
 },
 {
 modelNo: 'SP0046',
 description: 'Trix Carlo Straw Sipper - 210ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 63,
 usd: 0.7777777777777778,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=14.7mm',
 innerDimensions: 'L=16mm, B=30mm, H=29.4mm',
 cbm: 0.169,
 },
 {
 modelNo: 'SP0047',
 description: 'Viva Straw Sipper - 240ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 65,
 usd: 0.8024691358024691,
 moq: 3600,
 monoDimensions: 'L=8mm, B=8mm, H=17mm',
 innerDimensions: 'L=16mm, B=24mm, H=34mm',
 cbm: 0.157,
 },
 {
 modelNo: 'SP0048',
 description: 'Viva Straw Sipper - 210ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 62,
 usd: 0.7654320987654321,
 moq: 3600,
 monoDimensions: 'L=8mm, B=8mm, H=16mm',
 innerDimensions: 'L=16mm, B=24mm, H=32mm',
 cbm: 0.147,
 },
 {
 modelNo: 'SP0049',
 description: 'Viva Stylo Straw Sipper - 300ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 67,
 usd: 0.8271604938271605,
 moq: 3600,
 monoDimensions: 'L=8mm, B=8mm, H=17mm',
 innerDimensions: 'L=16mm, B=24mm, H=34mm',
 cbm: 0.157,
 },
 {
 modelNo: 'SP0050',
 description: 'Viva Stylo Straw Sipper - 210ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 64,
 usd: 0.7901234567901234,
 moq: 3600,
 monoDimensions: 'L=8mm, B=8mm, H=16mm',
 innerDimensions: 'L=16mm, B=24mm, H=32mm',
 cbm: 0.147,
 },
 {
 modelNo: 'SP0051',
 description: 'Viva Carlo Straw Sipper - 270ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 67,
 usd: 0.8271604938271605,
 moq: 3600,
 monoDimensions: 'L=8mm, B=8mm, H=17mm',
 innerDimensions: 'L=16mm, B=24mm, H=34mm',
 cbm: 0.157,
 },
 {
 modelNo: 'SP0052',
 description: 'Viva Carlo Straw Sipper - 210ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 65,
 usd: 0.8024691358024691,
 moq: 3600,
 monoDimensions: 'L=8mm, B=8mm, H=16mm',
 innerDimensions: 'L=16mm, B=24mm, H=32mm',
 cbm: 0.147,
 },
 {
 modelNo: 'SP0053',
 description: 'Viva Zena Straw Sipper - 210ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 65,
 usd: 0.8024691358024691,
 moq: 3600,
 monoDimensions: 'L=8mm, B=8mm, H=16mm',
 innerDimensions: 'L=16mm, B=24mm, H=32mm',
 cbm: 0.147,
 },
 {
 modelNo: 'SP0054',
 description: 'Viva Zena Straw Sipper - 300ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 68,
 usd: 0.8395061728395061,
 moq: 3600,
 monoDimensions: 'L=8mm, B=8mm, H=17mm',
 innerDimensions: 'L=16mm, B=24mm, H=34mm',
 cbm: 0.157,
 },
 {
 modelNo: 'SP0055',
 description: 'Penguin Straw Cup with tilted Handle - 210ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 57,
 usd: 0.7037037037037037,
 moq: 3600,
 monoDimensions: 'L=8.5mm, B=11.5mm, H=17mm',
 innerDimensions: 'L=17mm, B=34.5mm, H=34mm',
 cbm: 0.239,
 },
 {
 modelNo: 'SP0056',
 description: 'Crystal Hood Spout Cup with Tilted Handle - 210ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 60,
 usd: 0.7407407407407407,
 moq: 3600,
 monoDimensions: 'L=8.5mm, B=11.5mm, H=17mm',
 innerDimensions: 'L=17mm, B=34.5mm, H=34mm',
 cbm: 0.239,
 },
 {
 modelNo: 'SP0057',
 description: 'Giga Handle Straw Sipper with Base - 180ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 65,
 usd: 0.8024691358024691,
 moq: 3600,
 monoDimensions: 'L=8mm, B=11mm, H=16mm',
 innerDimensions: 'L=16mm, B=33mm, H=32mm',
 cbm: 0.203,
 },
 {
 modelNo: 'SP0058',
 description: 'Giga Handle Straw Sipper with Base - 300ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 70,
 usd: 0.8641975308641975,
 moq: 3600,
 monoDimensions: 'L=8mm, B=11mm, H=21mm',
 innerDimensions: 'L=16mm, B=33mm, H=42mm',
 cbm: 0.266,
 },
 {
 modelNo: 'SP0059',
 description: 'Giga Hanging Straw Sipper with Base - 180ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 65,
 usd: 0.8024691358024691,
 moq: 3600,
 monoDimensions: 'L=8mm, B=9mm, H=16mm',
 innerDimensions: 'L=16mm, B=27mm, H=32mm',
 cbm: 0.166,
 },
 {
 modelNo: 'SP0060',
 description: 'Giga Hanging Straw Sipper with Base - 300ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 70,
 usd: 0.8641975308641975,
 moq: 3600,
 monoDimensions: 'L=8mm, B=9mm, H=21mm',
 innerDimensions: 'L=16mm, B=27mm, H=42mm',
 cbm: 0.218,
 },
 {
 modelNo: 'SP0061',
 description: 'Rotate Straw Dolphin Bottle Finger Grip Handle - 240ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 60,
 usd: 0.7407407407407407,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=17mm',
 innerDimensions: 'L=16mm, B=30mm, H=34mm',
 cbm: 0.196,
 },
 {
 modelNo: 'SP0062',
 description: 'Rotate Straw Stylo Bottle Finger Grip Handle - 300ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 65,
 usd: 0.8024691358024691,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=17mm',
 innerDimensions: 'L=16mm, B=30mm, H=34mm',
 cbm: 0.196,
 },
 {
 modelNo: 'SP0063',
 description: 'Rotate Straw Stylo Bottle Finger Grip Handle - 210ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 60,
 usd: 0.7407407407407407,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=14.7mm',
 innerDimensions: 'L=16mm, B=30mm, H=29.4mm',
 cbm: 0.169,
 },
 {
 modelNo: 'SP0064',
 description: 'Rotate Straw Carlo Bottle Curvy Handle - 270ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 65,
 usd: 0.8024691358024691,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=17.5mm',
 innerDimensions: 'L=16mm, B=30mm, H=35mm',
 cbm: 0.202,
 },
 {
 modelNo: 'SP0065',
 description: 'Rotate Straw Carlo Bottle Curvy Handle - 210ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 63,
 usd: 0.7777777777777778,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=17mm',
 innerDimensions: 'L=16mm, B=30mm, H=34mm',
 cbm: 0.196,
 },
 {
 modelNo: 'SP0066',
 description: 'Rotate Straw Momo Bottle Curvy Handle - 240ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 66,
 usd: 0.8148148148148148,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=17.5mm',
 innerDimensions: 'L=16mm, B=30mm, H=35mm',
 cbm: 0.202,
 },
 {
 modelNo: 'SP0067',
 description: 'Rotate Straw Momo Bottle Curvy Handle - 210ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 62,
 usd: 0.7654320987654321,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=17mm',
 innerDimensions: 'L=16mm, B=30mm, H=34mm',
 cbm: 0.196,
 },
 {
 modelNo: 'SP0068',
 description: 'Penguin Straw Stylo Bottle Finger Grip Handle - 300ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 67,
 usd: 0.8271604938271605,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=17mm',
 innerDimensions: 'L=16mm, B=30mm, H=34mm',
 cbm: 0.196,
 },
 {
 modelNo: 'SP0069',
 description: 'Penguin Straw Stylo Bottle Finger Grip Handle - 210ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 64,
 usd: 0.7901234567901234,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=14.7mm',
 innerDimensions: 'L=16mm, B=30mm, H=29.4mm',
 cbm: 0.169,
 },
 {
 modelNo: 'SP0070',
 description: 'Penguin Straw Zack Bottle Finger Grip Handle - 330ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 70,
 usd: 0.8641975308641975,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=18mm',
 innerDimensions: 'L=16mm, B=30mm, H=36mm',
 cbm: 0.207,
 },
 {
 modelNo: 'SP0071',
 description: 'Penguin Straw Zack Bottle Finger Grip Handle - 150ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 60,
 usd: 0.7407407407407407,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=14.7mm',
 innerDimensions: 'L=16mm, B=32mm, H=29.4mm',
 cbm: 0.169,
 },
 {
 modelNo: 'SP0072',
 description: 'Bullet Hood Soft Spout Curvy Handle Stylo Bottle - 300ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 68,
 usd: 0.8395061728395061,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=17mm',
 innerDimensions: 'L=16mm, B=30mm, H=34mm',
 cbm: 0.196,
 },
 {
 modelNo: 'SP0073',
 description: 'Bullet Hood Soft Spout Curvy Handle Stylo Bottle - 210ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 65,
 usd: 0.8024691358024691,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=14.7mm',
 innerDimensions: 'L=16mm, B=30mm, H=29.4mm',
 cbm: 0.169,
 },
 {
 modelNo: 'SP0074',
 description: 'Bullet Hood Soft Spout Finger Grip Handle Dolphin Bottle - 250ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 65,
 usd: 0.8024691358024691,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=17mm',
 innerDimensions: 'L=16mm, B=30mm, H=34mm',
 cbm: 0.196,
 },
 {
 modelNo: 'SP0075',
 description: 'Bullet Hood Soft Spout Finger Grip Handle Dolphin Bottle - 150ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 62,
 usd: 0.7654320987654321,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=14.7mm',
 innerDimensions: 'L=16mm, B=30mm, H=29.44mm',
 cbm: 0.169,
 },
 {
 modelNo: 'SP0076',
 description: 'Bullet Hood Straw Spout 2 Tone Handle Zack Bottle - 330ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 70,
 usd: 0.8641975308641975,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=18mm',
 innerDimensions: 'L=16mm, B=30mm, H=36mm',
 cbm: 0.207,
 },
 {
 modelNo: 'SP0077',
 description: 'Bullet Hood Straw Spout 2 Tone Handle Zack Bottle - 150ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 68,
 usd: 0.8395061728395061,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=14.7mm',
 innerDimensions: 'L=16mm, B=30mm, H=29.4mm',
 cbm: 0.169,
 },
 {
 modelNo: 'SP0078',
 description: 'Crystal Hood Soft Spout Finger Grip Handle Stylo Bottle - 300ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 65,
 usd: 0.8024691358024691,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=17mm',
 innerDimensions: 'L=16mm, B=30mm, H=34mm',
 cbm: 0.196,
 },
 {
 modelNo: 'SP0079',
 description: 'Crystal Hood Soft Spout Finger Grip Handle Stylo Bottle - 210ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 63,
 usd: 0.7777777777777778,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=14.7mm',
 innerDimensions: 'L=16mm, B=30mm, H=29.4mm',
 cbm: 0.169,
 },
 {
 modelNo: 'SP0080',
 description: 'Crystal Hood Soft Spout Finger Grip Handle Carlo Bottle - 270ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 66,
 usd: 0.8148148148148148,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=18mm',
 innerDimensions: 'L=16mm, B=30mm, H=36mm',
 cbm: 0.207,
 },
 {
 modelNo: 'SP0081',
 description: 'Crystal Hood Soft Spout Finger Grip Handle Carlo Bottle - 210ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 64,
 usd: 0.7901234567901234,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=17mm',
 innerDimensions: 'L=16mm, B=30mm, H=34mm',
 cbm: 0.196,
 },
 {
 modelNo: 'SP0082',
 description: 'Crystal Hood Straw Spout Finger Grip Handle Zena Bottle - 300ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 68,
 usd: 0.8395061728395061,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=18mm',
 innerDimensions: 'L=16mm, B=30mm, H=36mm',
 cbm: 0.207,
 },
 {
 modelNo: 'SP0083',
 description: 'Crystal Hood Straw Spout Finger Grip Handle Zena Bottle - 180ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 65,
 usd: 0.8024691358024691,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=17mm',
 innerDimensions: 'L=16mm, B=30mm, H=34mm',
 cbm: 0.196,
 },
 {
 modelNo: 'SP0084',
 description: 'Crystal Hood Straw Spout Curvy Handle Zack Bottle - 300ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 68,
 usd: 0.8395061728395061,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=18mm',
 innerDimensions: 'L=16mm, B=30mm, H=36mm',
 cbm: 0.207,
 },
 {
 modelNo: 'SP0085',
 description: 'Crystal Hood Straw Spout Curvy Handle Zack Bottle - 150ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 65,
 usd: 0.8024691358024691,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=17mm',
 innerDimensions: 'L=16mm, B=30mm, H=34mm',
 cbm: 0.196,
 },
 {
 modelNo: 'SP0086',
 description: 'Bullet Hood Straw Spout Momo Accessories Zena Bottle - 300ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 67,
 usd: 0.8271604938271605,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=20mm',
 innerDimensions: 'L=16mm, B=30mm, H=40mm',
 cbm: 0.2304,
 },
 {
 modelNo: 'SP0087',
 description: 'Bullet Hood Straw Spout Momo Accessories Zena Bottle - 180ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 65,
 usd: 0.8024691358024691,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=17mm',
 innerDimensions: 'L=16mm, B=30mm, H=34mm',
 cbm: 0.196,
 },
 {
 modelNo: 'SP0088',
 description: 'Superflo Hood Soft Spout Momo Accessories Carlo Bottle - 270ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 70,
 usd: 0.8641975308641975,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=20mm',
 innerDimensions: 'L=16mm, B=30mm, H=40mm',
 cbm: 0.2304,
 },
 {
 modelNo: 'SP0089',
 description: 'Superflo Hood Soft Spout Momo Accessories Carlo Bottle - 210ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 68,
 usd: 0.8395061728395061,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=17mm',
 innerDimensions: 'L=16mm, B=30mm, H=34mm',
 cbm: 0.196,
 },
 {
 modelNo: 'SP0090',
 description: 'Bullet Hood Soft Spout Momo Accessories Stylo Bottle - 330ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 70,
 usd: 0.8641975308641975,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=17mm',
 innerDimensions: 'L=16mm, B=30mm, H=34mm',
 cbm: 0.196,
 },
 {
 modelNo: 'SP0091',
 description: 'Bullet Hood Soft Spout Momo Accessories Stylo Bottle - 210ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 68,
 usd: 0.8395061728395061,
 moq: 3600,
 monoDimensions: 'L=8mm, B=10mm, H=17mm',
 innerDimensions: 'L=16mm, B=30mm, H=34mm',
 cbm: 0.196,
 },
 {
 modelNo: 'SP0092',
 description: 'Rotate Straw Carlo Bottle - 270ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 65,
 usd: 0.8024691358024691,
 moq: 3600,
 monoDimensions: 'L=7.8mm, B=9.9mm, H=18.5mm',
 innerDimensions: 'L=15.6mm, B=29.7mm, H=37mm',
 cbm: 0.206,
 },
 {
 modelNo: 'SP0093',
 description: 'Rotate Straw Zena Bottle - 300ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 65,
 usd: 0.8024691358024691,
 moq: 3600,
 monoDimensions: 'L=7.8mm, B=9.9mm, H=18.5mm',
 innerDimensions: 'L=15.6mm, B=29.7mm, H=37mm',
 cbm: 0.206,
 },
 {
 modelNo: 'SP0094',
 description: 'KK Hard Spout Sipper - 180ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 40,
 usd: 0.49382716049382713,
 moq: 3600,
 monoDimensions: 'L=8.1mm, B=8.1mm, H=13.3mm',
 innerDimensions: 'L=16.2mm, B=24.3mm, H=26.6mm',
 cbm: 0.1256,
 }
 ]
 },
 {
 id: 'teethers-pacifiers',
 name: 'Teethers & Pacifiers',
 displayName: 'Teethers & Pacifiers',
 description: 'Safe and soothing teethers and pacifiers for baby comfort and development. Made with food-grade materials.',
 image: '/images/Teethers & Pacifiers JPEG/TP0001.JPG',
 products: [
 {
 modelNo: 'TP0001',
 description: 'EVA Water Filled Teether - Apple',
 packaging: 'Blister Card',
 inner: 24,
 outer: 288,
 inr: 30,
 usd: 0.3,
 moq: 3600,
 sNo: 1,
 monoDimensions: 'L=2.5mm, B=8.3mm, H=9.7mm',
 innerDimensions: 'L=30mm, B=8.3mm, H=9.7mm',
 masterDimensions: 'L=90mm, B=16.6mm, H=19.4mm',
 cbm: 0.02898,
 },
 {
 modelNo: 'TP0002',
 description: 'EVA Water Filled Teether - Mango',
 packaging: 'Blister Card',
 inner: 24,
 outer: 288,
 inr: 30,
 usd: 0.3,
 moq: 3600,
 sNo: 2,
 monoDimensions: 'L=2.5mm, B=8.3mm, H=9.7mm',
 innerDimensions: 'L=30mm, B=8.3mm, H=9.7mm',
 masterDimensions: 'L=90mm, B=16.6mm, H=19.4mm',
 cbm: 0.02898,
 },
 {
 modelNo: 'TP0003',
 description: 'EVA Water Filled Teether - Strawberry',
 packaging: 'Blister Card',
 inner: 24,
 outer: 288,
 inr: 30,
 usd: 0.3,
 moq: 3600,
 sNo: 3,
 monoDimensions: 'L=2.5mm, B=8.3mm, H=9.7mm',
 innerDimensions: 'L=30mm, B=8.3mm, H=9.7mm',
 masterDimensions: 'L=90mm, B=16.6mm, H=19.4mm',
 cbm: 0.02898,
 },
 {
 modelNo: 'TP0004',
 description: 'EVA Water Filled Teether - Face',
 packaging: 'Blister Card',
 inner: 24,
 outer: 288,
 inr: 30,
 usd: 0.3,
 moq: 3600,
 sNo: 4,
 monoDimensions: 'L=2.5mm, B=8.3mm, H=9.7mm',
 innerDimensions: 'L=30mm, B=8.3mm, H=9.7mm',
 masterDimensions: 'L=90mm, B=16.6mm, H=19.4mm',
 cbm: 0.02898,
 },
 {
 modelNo: 'TP0005',
 description: 'EVA Water Filled Teether - Hand',
 packaging: 'Blister Card',
 inner: 24,
 outer: 288,
 inr: 30,
 usd: 0.3,
 moq: 3600,
 sNo: 5,
 monoDimensions: 'L=2.5mm, B=8.3mm, H=9.7mm',
 innerDimensions: 'L=30mm, B=8.3mm, H=9.7mm',
 masterDimensions: 'L=90mm, B=16.6mm, H=19.4mm',
 cbm: 0.02898,
 },
 {
 modelNo: 'TP0006',
 description: 'EVA Water Filled Teether - Foot',
 packaging: 'Blister Card',
 inner: 24,
 outer: 288,
 inr: 30,
 usd: 0.3,
 moq: 3600,
 sNo: 6,
 monoDimensions: 'L=2.5mm, B=8.3mm, H=9.7mm',
 innerDimensions: 'L=30mm, B=8.3mm, H=9.7mm',
 masterDimensions: 'L=90mm, B=16.6mm, H=19.4mm',
 cbm: 0.02898,
 },
 {
 modelNo: 'TP0007',
 description: 'Silicone Teether - Anchor',
 packaging: 'Blister Card',
 inner: 24,
 outer: 288,
 inr: 60,
 usd: 0.7,
 moq: 3600,
 sNo: 7,
 monoDimensions: 'L=2.5mm, B=8.3mm, H=9.7mm',
 innerDimensions: 'L=30mm, B=8.3mm, H=9.7mm',
 masterDimensions: 'L=90mm, B=16.6mm, H=19.4mm',
 cbm: 0.02898,
 },
 {
 modelNo: 'TP0008',
 description: 'Silicone Teether - Tylo',
 packaging: 'Blister Card',
 inner: 24,
 outer: 288,
 inr: 50,
 usd: 0.6,
 moq: 3600,
 sNo: 8,
 monoDimensions: 'L=2.5mm, B=8.3mm, H=9.7mm',
 innerDimensions: 'L=30mm, B=8.3mm, H=9.7mm',
 masterDimensions: 'L=90mm, B=16.6mm, H=19.4mm',
 cbm: 0.02898,
 },
 {
 modelNo: 'TP0009',
 description: 'Silicone Teether - Zuzu',
 packaging: 'Blister Card',
 inner: 24,
 outer: 288,
 inr: 50,
 usd: 0.55,
 moq: 3600,
 sNo: 9,
 monoDimensions: 'L=2.5mm, B=8.3mm, H=9.7mm',
 innerDimensions: 'L=30mm, B=8.3mm, H=9.7mm',
 masterDimensions: 'L=90mm, B=16.6mm, H=19.4mm',
 cbm: 0.02898,
 },
 {
 modelNo: 'TP0010',
 description: 'Silicone Teether - Trio',
 packaging: 'Blister Card',
 inner: 24,
 outer: 288,
 inr: 75,
 usd: 0.95,
 moq: 3600,
 sNo: 10,
 monoDimensions: 'L=15.5mm, B=19mm, D=3.8mm',
 innerDimensions: 'L=15.5mm, B=19mm, D=45.6mm',
 masterDimensions: 'L=31mm, B=38mm, D=136.8mm',
 cbm: 0.1612,
 },
 {
 modelNo: 'TP0011',
 description: 'Pacifier - Butterfly',
 packaging: 'Blister Card',
 inner: 24,
 outer: 288,
 inr: 27.5,
 usd: 0.35,
 moq: 3600,
 sNo: 11,
 monoDimensions: 'L=8.2mm, B=13mm, H=5.2mm',
 innerDimensions: 'L=8.2mm, B=13mm, H=62.4mm',
 masterDimensions: 'L=16.4mm, B=26mm, H=187.2mm',
 cbm: 0.0798,
 },
 {
 modelNo: 'TP0012',
 description: 'Pacifier - Ruby',
 packaging: 'Blister Card',
 inner: 24,
 outer: 288,
 inr: 28.5,
 usd: 0.35,
 moq: 3600,
 sNo: 12,
 monoDimensions: 'L=8.2mm, B=13mm, H=4.7mm',
 innerDimensions: 'L=8.2mm, B=13mm, H=56.4mm',
 masterDimensions: 'L=16.4mm, B=26mm, H=169.2mm',
 cbm: 0.0722,
 },
 {
 modelNo: 'TP0013',
 description: 'Pacifier - Hearty',
 packaging: 'Blister Card',
 inner: 24,
 outer: 288,
 inr: 35,
 usd: 0.42,
 moq: 3600,
 sNo: 13,
 monoDimensions: 'L=8.2mm, B=13mm, H=4.7mm',
 innerDimensions: 'L=8.2mm, B=13mm, H=56.4mm',
 masterDimensions: 'L=16.4mm, B=26mm, H=169.2mm',
 cbm: 0.0722,
 },
 {
 modelNo: 'TP0014',
 description: 'Pacifier - Simple',
 packaging: 'Blister Card',
 inner: 24,
 outer: 288,
 inr: 30,
 usd: 0.35,
 moq: 3600,
 sNo: 14,
 monoDimensions: 'L=8.2mm, B=13mm, H=4.7mm',
 innerDimensions: 'L=8.2mm, B=13mm, H=56.4mm',
 masterDimensions: 'L=16.4mm, B=26mm, H=169.2mm',
 cbm: 0.0722,
 },
 {
 modelNo: 'TP0015',
 description: 'Pacifier - Circulo',
 packaging: 'Blister Card',
 inner: 24,
 outer: 288,
 inr: 35,
 usd: 0.42,
 moq: 3600,
 sNo: 15,
 monoDimensions: 'L=8.2mm, B=13mm, H=4.7mm',
 innerDimensions: 'L=8.2mm, B=13mm, H=56.4mm',
 masterDimensions: 'L=16.4mm, B=26mm, H=169.2mm',
 cbm: 0.0722,
 },
 {
 modelNo: 'TP0018',
 description: 'Nibbler Animal Shape',
 packaging: 'Blister Card',
 inner: 12,
 outer: 144,
 inr: 50,
 usd: 0.65,
 moq: 3600,
 sNo: 16,
 monoDimensions: 'L=11.5mm, B=18mm, D=4.2mm',
 innerDimensions: 'L=11.5mm, B=18mm, D=50.4mm',
 masterDimensions: 'L=23mm, B=36mm, D=151.2mm',
 cbm: 0.1252,
 },
 {
 modelNo: 'TP0019',
 description: 'Silicone Pacifier - SSR',
 packaging: 'Blister Card',
 inner: 24,
 outer: 288,
 inr: 45,
 usd: 0.55,
 moq: 3600,
 sNo: 17,
 monoDimensions: 'L=10.2mm, B=15.2mm, D=4.5mm',
 innerDimensions: 'L=10.2mm, B=15.2mm, D=54mm',
 masterDimensions: 'L=20.4mm, B=30.4mm, D=162mm',
 cbm: 0.1004,
 },
 {
 modelNo: 'TP0020',
 description: 'PP + EVA Water Teether Lion',
 packaging: 'Blister Card',
 inner: 24,
 outer: 288,
 inr: 45,
 usd: 0.55,
 moq: 3600,
 sNo: 18,
 monoDimensions: 'L=2.5mm, B=8.3mm, H=9.7mm',
 innerDimensions: 'L=30mm, B=8.3mm, H=9.7mm',
 masterDimensions: 'L=90mm, B=16.6mm, H=19.4mm',
 cbm: 0.02898,
 },
 {
 modelNo: 'TP0021',
 description: 'PP + EVA Water Teether Tiger',
 packaging: 'Blister Card',
 inner: 24,
 outer: 288,
 inr: 45,
 usd: 0.55,
 moq: 3600,
 sNo: 19,
 monoDimensions: 'L=2.5mm, B=8.3mm, H=9.7mm',
 innerDimensions: 'L=30mm, B=8.3mm, H=9.7mm',
 masterDimensions: 'L=90mm, B=16.6mm, H=19.4mm',
 cbm: 0.02898,
 },
 {
 modelNo: 'TP0022',
 description: 'PP + EVA Water Teether Giraffe',
 packaging: 'Blister Card',
 inner: 24,
 outer: 288,
 inr: 45,
 usd: 0.55,
 moq: 3600,
 sNo: 20,
 monoDimensions: 'L=2.5mm, B=8.3mm, H=9.7mm',
 innerDimensions: 'L=30mm, B=8.3mm, H=9.7mm',
 masterDimensions: 'L=90mm, B=16.6mm, H=19.4mm',
 cbm: 0.02898,
 },
 {
 modelNo: 'TP0023',
 description: 'Capsicum 2 Color EVA Water',
 packaging: 'Blister Card',
 inner: 24,
 outer: 288,
 inr: 35,
 usd: 0.43209876543209874,
 moq: 3600,
 sNo: 21,
 monoDimensions: 'L=2.5mm, B=8.3mm, H=9.7mm',
 innerDimensions: 'L=30mm, B=8.3mm, H=9.7mm',
 masterDimensions: 'L=90mm, B=16.6mm, H=19.4mm',
 cbm: 0.02898,
 },
 {
 modelNo: 'TP0024',
 description: 'Pear 2 Color EVA Water',
 packaging: 'Blister Card',
 inner: 24,
 outer: 288,
 inr: 35,
 usd: 0.55,
 moq: 3600,
 sNo: 22,
 monoDimensions: 'L=2.5mm, B=8.3mm, H=9.7mm',
 innerDimensions: 'L=30mm, B=8.3mm, H=9.7mm',
 masterDimensions: 'L=90mm, B=16.6mm, H=19.4mm',
 cbm: 0.02898,
 },
 {
 modelNo: 'TP0016',
 description: 'Strip Pacifier Clip',
 packaging: 'Blister Card',
 inner: 24,
 outer: 288,
 inr: 45,
 usd: 0.6,
 moq: 3600,
 sNo: 23,
 monoDimensions: 'L=8.2mm, B=13mm, H=4.7mm',
 innerDimensions: 'L=8.2mm, B=13mm, H=56.4mm',
 masterDimensions: 'L=16.4mm, B=26mm, H=187.2mm',
 cbm: 0.0722,
 },
 {
 modelNo: 'TP0017',
 description: 'Beads Pacifier Clip',
 packaging: 'Blister Card',
 inner: 24,
 outer: 288,
 inr: 50,
 usd: 0.65,
 moq: 3600,
 sNo: 24,
 monoDimensions: 'L=8.2mm, B=13mm, H=4.7mm',
 innerDimensions: 'L=8.2mm, B=13mm, H=56.4mm',
 masterDimensions: 'L=16.4mm, B=26mm, H=187.2mm',
 cbm: 0.0722,
 }
 ]
 },
 {
 id: 'cutlery-tableware',
 name: 'Cutlery & Tableware',
 displayName: 'Cutlery & Tableware',
 description: 'Complete feeding solutions including spoons, forks, bowls and plates for solid food introduction.',
 image: '/images/Cutlery & Tableware JPEG/CT0001.JPG',
 products: [
 {
 modelNo: 'CT0001',
 description: 'Food Processing Set',
 packaging: 'Gift Box',
 inner: 12,
 outer: 72,
 inr: 120,
 usd: 1.4814814814814814,
 moq: 3600,
 },
 {
 modelNo: 'CT0002',
 description: 'Suction Bowl with Lid & Cutlery',
 packaging: 'Gift Box',
 inner: 12,
 outer: 144,
 inr: 65,
 usd: 0.8024691358024691,
 moq: 3600,
 monoDimensions: 'L=11.5mm, B=13mm, H=7mm',
 innerDimensions: 'L=23mm, B=39mm, H=14mm',
 cbm: 0.1507,
 },
 {
 modelNo: 'CT0003',
 description: 'Stage 1 Feeding Bowl - 2pcs',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 55,
 usd: 0.6790123456790124,
 moq: 3600,
 monoDimensions: 'L=10.5mm, B=13.5mm, H=7mm',
 innerDimensions: 'L=21mm, B=40.5mm, H=14mm',
 cbm: 0.1429,
 },
 {
 modelNo: 'CT0004',
 description: 'Round Feeding Bowl with Anti Skid Base - 2pcs',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 65,
 usd: 0.8024691358024691,
 moq: 3600,
 monoDimensions: 'NA',
 },
 {
 modelNo: 'CT0005',
 description: 'Oval Feeding Plate with Anti Skid Base - 2pcs',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 70,
 usd: 0.8641975308641975,
 moq: 3600,
 monoDimensions: 'L=11.5mm, B=18mm, H=8mm',
 innerDimensions: 'L=23mm, B=54mm, H=16mm',
 cbm: 0.2385,
 },
 {
 modelNo: 'CT0006',
 description: 'Feeding Bowl with Soft Touch Handle - 2pcs',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 70,
 usd: 0.8641975308641975,
 moq: 3600,
 monoDimensions: 'L=11.5mm, B=15.5mm, H=9mm',
 innerDimensions: 'L=23mm, B=46.5mm, H=18mm',
 cbm: 0.2309,
 },
 {
 modelNo: 'CT0007',
 description: 'Feeding Plate with Soft Touch Handle - 2pcs',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 70,
 usd: 0.8641975308641975,
 moq: 3600,
 monoDimensions: 'L=15.3mm, B=20.3mm, H=6.8mm',
 innerDimensions: 'L=30.6mm, B=60.9mm, H=13.6mm',
 cbm: 0.3043,
 },
 {
 modelNo: 'CT0008',
 description: 'Partition Plate with Soft Touch Handle',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 80,
 usd: 0.9876543209876543,
 moq: 3600,
 monoDimensions: 'L=18mm, B=25.5mm, H=3.8mm',
 innerDimensions: 'L=36mm, B=76.5mm, H=7.6mm',
 cbm: 0.2512,
 },
 {
 modelNo: 'CT0009',
 description: 'Handle Feeding Bowl with Lid & Spoon',
 packaging: 'Header Card',
 inner: 12,
 outer: 72,
 inr: 65,
 usd: 0.8024691358024691,
 moq: 3600,
 monoDimensions: 'L=10mm, B=15mm, H=8mm',
 innerDimensions: 'L=20mm, B=45mm, H=16mm',
 cbm: 0.1728,
 },
 {
 modelNo: 'CT0010',
 description: '2 Tone Cutlery - 2pcs',
 packaging: 'Blister Card',
 inner: 24,
 outer: 288,
 inr: 30,
 usd: 0.37037037037037035,
 moq: 3600,
 monoDimensions: 'L=11.8mm, B=19.8mm, D=2mm',
 innerDimensions: 'L=11.8mm, B=19.8mm, D=24mm',
 cbm: 0.0673,
 },
 {
 modelNo: 'CT0011',
 description: 'Polka Cutlery - 2pcs',
 packaging: 'Blister Card',
 inner: 24,
 outer: 288,
 inr: 32,
 usd: 0.3950617283950617,
 moq: 3600,
 monoDimensions: 'L=11.8mm, B=19.8mm, D=2mm',
 innerDimensions: 'L=11.8mm, B=19.8mm, D=24mm',
 cbm: 0.0673,
 },
 {
 modelNo: 'CT0012',
 description: 'SImple Straight Cutlery - 2pcs',
 packaging: 'Blister Card',
 inner: 24,
 outer: 288,
 inr: 28,
 usd: 0.345679012345679,
 moq: 3600,
 monoDimensions: 'L=11.8mm, B=19.8mm, D=2mm',
 innerDimensions: 'L=11.8mm, B=19.8mm, D=24mm',
 cbm: 0.0673,
 },
 {
 modelNo: 'CT0013',
 description: 'Simple Curvy Cutlery - 2pcs',
 packaging: 'Blister Card',
 inner: 24,
 outer: 288,
 inr: 28,
 usd: 0.345679012345679,
 moq: 3600,
 monoDimensions: 'L=11.8mm, B=19.8mm, D=2mm',
 innerDimensions: 'L=11.8mm, B=19.8mm, D=24mm',
 cbm: 0.0673,
 },
 {
 modelNo: 'CT0014',
 description: 'Heat Sensitive Spoons - 2pcs',
 packaging: 'Blister Card',
 inner: 24,
 outer: 288,
 inr: 40,
 usd: 0.49382716049382713,
 moq: 3600,
 monoDimensions: 'L=11.8mm, B=19.8mm, D=2mm',
 innerDimensions: 'L=11.8mm, B=19.8mm, D=24mm',
 cbm: 0.0673,
 },
 {
 modelNo: 'CT0015',
 description: 'Feeding Travel Food Bowl with Cutlery',
 packaging: 'Window Box',
 inner: 12,
 outer: 72,
 inr: 85,
 usd: 1.0493827160493827,
 moq: 3600,
 monoDimensions: 'L=9mm, B=15mm, H=19.8mm',
 innerDimensions: 'L=18mm, B=45mm, H=39.6mm',
 cbm: 0.3849,
 },
 {
 modelNo: 'CT0016',
 description: 'Simple Feeding Bowl - 2pcs',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 65,
 usd: 0.8024691358024691,
 moq: 3600,
 monoDimensions: 'L=11.5mm, B=16.5mm, H=8mm',
 innerDimensions: 'L=23mm, B=49.5mm, H=16mm',
 cbm: 0.2186,
 },
 {
 modelNo: 'CT0017',
 description: 'Cutlery with Travel Case - 2pcs',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 45,
 usd: 0.5555555555555556,
 moq: 3600,
 monoDimensions: 'L=6.3mm, B=14.5mm, D=2.3mm',
 innerDimensions: 'L=6.3mm, B=14.5mm, D=27.6mm',
 cbm: 0.0303,
 },
 {
 modelNo: 'CT0018',
 description: 'ST Feeding Bowl - 2pcs',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 60,
 usd: 0.7407407407407407,
 moq: 3600,
 monoDimensions: 'L=14.8mm, B=14.8mm, H=6.5mm',
 innerDimensions: 'L=29.6mm, B=44.4mm, H=13mm',
 cbm: 0.205,
 },
 {
 modelNo: 'CT0019',
 description: 'ST Feeding Plate - 2pcs',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 70,
 usd: 0.8641975308641975,
 moq: 3600,
 monoDimensions: 'L=20mm, B=20mm, H=5mm',
 innerDimensions: 'L=40mm, B=60mm, H=10mm',
 cbm: 0.288,
 },
 {
 modelNo: 'CT0020',
 description: 'ST Water Tumbler - 3pcs',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 60,
 usd: 0.7407407407407407,
 moq: 3600,
 monoDimensions: 'L=7mm, B=7mm, H=17mm',
 innerDimensions: 'L=14mm, B=21mm, H=34mm',
 cbm: 0.1201,
 },
 {
 modelNo: 'CT0021',
 description: 'Simple Cup with Handle',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 35,
 usd: 0.43209876543209874,
 moq: 3600,
 monoDimensions: 'L=8.5mm, B=10.8mm, H=7.3mm',
 innerDimensions: 'L=17mm, B=32.4mm, H=14.6mm',
 cbm: 0.0965,
 },
 {
 modelNo: 'CT0022',
 description: 'Spout Tumbler with Anti Skid Base',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 40,
 usd: 0.49382716049382713,
 moq: 3600,
 monoDimensions: 'L=8.4mm, B=12.8mm, H=10mm',
 innerDimensions: 'L=16.8mm, B=38.4mm, H=20mm',
 cbm: 0.1548,
 },
 {
 modelNo: 'CT0023',
 description: 'Simple Cup with Cover',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 45,
 usd: 0.5555555555555556,
 moq: 3600,
 monoDimensions: 'L=8.5mm, B=10.8mm, H=7.5mm',
 innerDimensions: 'L=17mm, B=32.4mm, H=15mm',
 cbm: 0.0991,
 },
 {
 modelNo: 'CT0024',
 description: 'Oval Partition Plate - 2pcs',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 65,
 usd: 0.8024691358024691,
 moq: 3600,
 monoDimensions: 'L=16.8mm, B=20mm, H=5mm',
 innerDimensions: 'L=33.6mm, B=60mm, H=10mm',
 cbm: 0.2419,
 },
 {
 modelNo: 'CT0025',
 description: 'PP Cereal Feeder - 125ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 28,
 usd: 0.345679012345679,
 moq: 3601,
 },
 {
 modelNo: 'CT0026',
 description: 'PP Cereal Feeder - 250ml',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 30,
 usd: 0.37037037037037035,
 moq: 3602,
 }
 ]
 },
 {
 id: 'mothercare',
 name: 'MotherCare',
 displayName: 'MotherCare Products',
 description: 'Essential products for nursing mothers including breast pumps, nipple shields and accessories.',
 image: '/images/MotherCare JPEG/MC0001.JPG',
 products: [
 {
 modelNo: 'MC0001',
 description: 'Nipple Shield with Case',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 45,
 usd: 0.5555555555555556,
 moq: 3600,
 sNo: 1,
 monoDimensions: 'L=8.5mm, B=8.5mm, H=5.5mm',
 innerDimensions: 'L=17mm, B=25.5mm, H=11mm',
 masterDimensions: 'L=34mm, B=76.5mm, H=22mm',
 cbm: 0.0572,
 },
 {
 modelNo: 'MC0002',
 description: 'Nipple Puller with Case',
 packaging: 'Mono Box',
 inner: 24,
 outer: 288,
 inr: 50,
 usd: 0.6172839506172839,
 moq: 3600,
 sNo: 2,
 monoDimensions: 'L=4.3mm, B=4.3mm, H=8mm',
 innerDimensions: 'L=8.6mm, B=12.9mm, H=16mm',
 masterDimensions: 'L=17.2mm, B=38.7mm, H=32mm',
 cbm: 0.0213,
 },
 {
 modelNo: 'MC0003',
 description: 'Compact Breast Pump - L Shape',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 60,
 usd: 0.7407407407407407,
 moq: 3600,
 sNo: 3,
 monoDimensions: 'L=10mm, B=10mm H=16mm',
 innerDimensions: 'L=20mm, B=30mm H=32mm',
 masterDimensions: 'L=40mm, B=90mm, H=64mm',
 cbm: 0.2304,
 },
 {
 modelNo: 'MC0004',
 description: 'Compact Breast Pump - I Shape',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 60,
 usd: 0.7407407407407407,
 moq: 3600,
 sNo: 4,
 monoDimensions: 'L=7.5mm, B=7.5mm, H=15.5mm',
 innerDimensions: 'L=15mm, B=22.5mm, H=31mm',
 masterDimensions: 'L=30mm, B=67.5mm, H=62mm',
 cbm: 0.1256,
 },
 {
 modelNo: 'MC0005',
 description: 'Std Neck Breast Pump',
 packaging: 'Mono Box',
 inner: 0,
 outer: 24,
 inr: 130,
 usd: 1.5,
 moq: 2000,
 sNo: 5,
 monoDimensions: 'L=9.5mm, B=13.1mm, H=19.5mm',
 innerDimensions: 'L=19mm, B=39.3mm, H=39mm',
 masterDimensions: 'L=38mm, B=117.9mm, H=78mm',
 cbm: 0.3495,
 },
 {
 modelNo: 'MC0006',
 description: 'Wide Neck Breast Pump',
 packaging: 'Mono Box',
 inner: 0,
 outer: 24,
 inr: 240,
 usd: 2.962962962962963,
 moq: 2000,
 sNo: 6,
 monoDimensions: 'L=9.1mm, B=16.5mm, H=21.4mm',
 innerDimensions: 'L=18.2mm, B=49.5mm, H=42.8mm',
 masterDimensions: 'L=36.4mm, B=148.5mm, H=85.6mm',
 cbm: 0.4629,
 },
 {
 modelNo: 'MC0007',
 description: 'Std.Neck Breast Milk Storage Containers - 3pcs Pack',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 55,
 usd: 0.6790123456790124,
 moq: 3600,
 sNo: 7,
 monoDimensions: 'L=5.3mm, B=16.3mm, H=11.5mm',
 innerDimensions: 'L=10.6mm, B=48.9mm, H=23mm',
 masterDimensions: 'L=21.2mm, B=146.7mm, H=46mm',
 cbm: 0.0143,
 },
 {
 modelNo: 'MC0008',
 description: 'Wide Neck Breast Milk Storage Containers - 3pcs Pack',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 75,
 usd: 0.9259259259259259,
 moq: 3600,
 sNo: 8,
 monoDimensions: 'L=7.5mm, B=23.5mm, H=10mm',
 innerDimensions: 'L=15mm, B=70.5mm, H=20mm',
 masterDimensions: 'L=30mm, B=211.5mm, H=40mm',
 cbm: 0.2538,
 }
 ]
 },
 {
 id: 'others',
 name: 'Others',
 displayName: 'Other Baby Products',
 description: 'Additional baby care products including bottle accessories, cleaning tools and storage solutions.',
 image: '/images/Others JPEG/OT0001.JPG',
 products: [
 {
 modelNo: 'OT0001',
 description: 'Bottle Tongs',
 packaging: 'Blister Card',
 inner: 12,
 outer: 144,
 inr: 55,
 usd: 0.6790123456790124,
 moq: 3600,
 sNo: 1,
 monoDimensions: 'L=9.5mm, B=29mm, H=6mm',
 innerDimensions: 'L=19mm, B=87mm, H=12mm',
 masterDimensions: 'L=38mm, B=261mm, H=24mm',
 cbm: 0.238,
 },
 {
 modelNo: 'OT0002',
 description: 'Nasal Aspirator',
 packaging: 'Blister Card',
 inner: 24,
 outer: 288,
 inr: 35,
 usd: 0.43209876543209874,
 moq: 3600,
 sNo: 2,
 monoDimensions: 'L=4.8mm, B=4.8mm, H=9mm',
 innerDimensions: 'L=9.6mm, B=14.4mm, H=27mm',
 masterDimensions: 'L=19.2mm, B=43.2mm H=81mm',
 cbm: 0.0672,
 },
 {
 modelNo: 'OT0003',
 description: 'Milk Powder Container',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 38,
 usd: 0.4691358024691358,
 moq: 3600,
 sNo: 3,
 monoDimensions: 'L=9.5mm, B=9.5mm, H=10mm',
 innerDimensions: 'L=19mm, B=28.5mm, H=20mm',
 masterDimensions: 'L=38mm, B=85.5mm, H=40mm',
 cbm: 0.13,
 },
 {
 modelNo: 'OT0004',
 description: '3 Tier Milk Powder Container',
 packaging: 'Mono Box',
 inner: 12,
 outer: 144,
 inr: 45,
 usd: 0.5555555555555556,
 moq: 3600,
 sNo: 4,
 monoDimensions: 'L=8mm, B=8mm, H=15mm',
 innerDimensions: 'L=16mm, B=24mm, H=30mm',
 masterDimensions: 'L=32mm, B=72mm, H=60mm',
 cbm: 0.1382,
 },
 {
 modelNo: 'OT0005',
 description: 'Bottle Brush - Sponge',
 packaging: 'Blister Card',
 inner: 12,
 outer: 144,
 inr: 55,
 usd: 0.6790123456790124,
 moq: 3600,
 sNo: 5,
 monoDimensions: 'L=10.5mm, B=36.5mm, D=6.3mm',
 innerDimensions: 'L=10.5mm, B=36.5mm, D=75.6mm',
 masterDimensions: 'L=21mm, B=73mm, D=226.8mm',
 cbm: 0.3476,
 },
 {
 modelNo: 'OT0006',
 description: 'Alpha Bottle Brush',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 30,
 usd: 0.37037037037037035,
 moq: 3600,
 sNo: 6,
 monoDimensions: 'L=10.5mm, B=36.5mm, D=6.3mm',
 innerDimensions: 'L=10.5mm, B=36.5mm, D=75.6mm',
 masterDimensions: 'L=21mm, B=73mm, D=226.8mm',
 cbm: 0.3476,
 },
 {
 modelNo: 'OT0007',
 description: 'Beta Bottle Brush',
 packaging: 'Header Card',
 inner: 12,
 outer: 144,
 inr: 30,
 usd: 0.37037037037037035,
 moq: 3600,
 sNo: 7,
 monoDimensions: 'L=10.5mm, B=36.5mm, D=6.3mm',
 innerDimensions: 'L=10.5mm, B=36.5mm, D=75.6mm',
 masterDimensions: 'L=21mm, B=73mm, D=226.8mm',
 cbm: 0.3476,
 },
 {
 modelNo: 'OT0008',
 description: '2 Tone Brush & Comb',
 packaging: 'Blister Card',
 inner: 12,
 outer: 144,
 inr: 55,
 usd: 0.6790123456790124,
 moq: 3600,
 sNo: 8,
 monoDimensions: 'L=12.5mm, B=19.9mm, D=1.5mm',
 innerDimensions: 'L=12.5mm, B=19.9mm, D=18mm',
 masterDimensions: 'L=25mm, B=39.8mm, D=54mm',
 cbm: 0.0537,
 },
 {
 modelNo: 'OT0009',
 description: '2 Tone Comb - 1pc',
 packaging: 'Blister Card',
 inner: 24,
 outer: 288,
 inr: 35,
 usd: 0.43209876543209874,
 moq: 3600,
 sNo: 9,
 monoDimensions: 'L=7mm, B=18.2mm, D=1mm',
 innerDimensions: 'L=7mm, B=18.2mm, D=12mm',
 masterDimensions: 'L=14mm, B=36.4mm, D=36mm',
 cbm: 0.0183,
 },
 {
 modelNo: 'OT0010',
 description: '2 Tone Comb - 2pcs',
 packaging: 'Blister Card',
 inner: 24,
 outer: 288,
 inr: 45,
 usd: 0.5555555555555556,
 moq: 3600,
 sNo: 10,
 monoDimensions: 'L=11.9mm, B=19.9mm, D=1mm',
 innerDimensions: 'L=11.9mm, B=19.9mm, D=12mm',
 masterDimensions: 'L=23.8mm, B=39.8mm, D=36mm',
 cbm: 0.0341,
 },
 {
 modelNo: 'OT0011',
 description: 'Curvy Comb - 1pc',
 packaging: 'Blister Card',
 inner: 24,
 outer: 288,
 inr: 25,
 usd: 0.30864197530864196,
 moq: 3600,
 sNo: 11,
 monoDimensions: 'L=6mm, B=19.9mm, D=1mm',
 innerDimensions: 'L=6mm, B=19.9mm, D=12mm',
 masterDimensions: 'L=12mm, B=39.8mm, D=36mm',
 cbm: 0.0172,
 },
 {
 modelNo: 'OT0012',
 description: 'Curvy Comb - 2pcs',
 packaging: 'Blister Card',
 inner: 24,
 outer: 288,
 inr: 35,
 usd: 0.43209876543209874,
 moq: 3600,
 sNo: 12,
 monoDimensions: 'L=10mm, B=19.9mm, D=1mm',
 innerDimensions: 'L=10mm, B=19.9mm, D=12mm',
 masterDimensions: 'L=20mm, B=39.8mm, D=36mm',
 cbm: 0.0287,
 },
 {
 modelNo: 'OT0013',
 description: 'Baby Brush - 0 Size',
 packaging: 'Blister Card',
 inner: 24,
 outer: 288,
 inr: 35,
 usd: 0.43209876543209874,
 moq: 3600,
 sNo: 13,
 monoDimensions: 'L=5.2mm, B=13.1mm, D=5.1mm',
 innerDimensions: 'L=5.2mm, B=13.1mm, D=61.2mm',
 masterDimensions: 'L=10.4mm, B=26.2mm, D=183.6mm',
 cbm: 0.05,
 },
 {
 modelNo: 'OT0014',
 description: 'Baby Brush - 1 Size',
 packaging: 'Blister Card',
 inner: 24,
 outer: 288,
 inr: 35,
 usd: 0.43209876543209874,
 moq: 3600,
 sNo: 14,
 monoDimensions: 'L=5.2mm, B=13.1mm, D=5.1mm',
 innerDimensions: 'L=5.2mm, B=13.1mm, D=61.2mm',
 masterDimensions: 'L=10.4mm, B=26.2mm, D=183.6mm',
 cbm: 0.05,
 },
 {
 modelNo: 'OT0015',
 description: 'Baby Brush - 2 Size',
 packaging: 'Blister Card',
 inner: 24,
 outer: 288,
 inr: 35,
 usd: 0.43209876543209874,
 moq: 3600,
 sNo: 15,
 monoDimensions: 'L=5.2mm, B=13.1mm, D=5.1mm',
 innerDimensions: 'L=5.2mm, B=13.1mm, D=61.2mm',
 masterDimensions: 'L=10.4mm, B=26.2mm, D=183.6mm',
 cbm: 0.05,
 },
 ],
 },
];

// Helper function to get category by ID
export const getCategoryById = (categoryId: string): ProductCategory | undefined => {
  return PRODUCT_CATEGORIES.find(category => category.id === categoryId);
};